[
  {
    "alpha2": "aar",
    "English": "Afar",
    "French": "afar",
    "German": "Afar",
    "Portuguese": "afar",
    "Italian": "Afar",
    "Spanish": "Afar",
    "Dutch": "Afar"
  },
  {
    "alpha2": "abk",
    "English": "Abkhazian",
    "French": "abkhaze",
    "German": "Abchasisch",
    "Portuguese": "abcázio",
    "Italian": "Abcaso",
    "Spanish": "Abkhaz",
    "Dutch": "Abchazisch"
  },
  {
    "alpha2": "ace",
    "English": "Achinese",
    "French": "aceh",
    "German": "Aceh-Sprache",
    "Portuguese": "achém; achinês",
    "Italian": "Aceh",
    "Spanish": "Acehneso",
    "Dutch": "Atjehs"
  },
  {
    "alpha2": "ach",
    "English": "Acoli",
    "French": "acoli",
    "German": "Acholi-Sprache",
    "Portuguese": "acholi; acoli",
    "Italian": "Acoli",
    "Spanish": "Acoli",
    "Dutch": "Akoli"
  },
  {
    "alpha2": "ada",
    "English": "Adangme",
    "French": "adangme",
    "German": "Adangme-Sprache",
    "Portuguese": "Dangbe",
    "Italian": "Adangme",
    "Spanish": "Adangme",
    "Dutch": "Adangme"
  },
  {
    "alpha2": "ady",
    "English": "Adyghe; Adygei",
    "French": "adyghé",
    "German": "Adygeisch",
    "Portuguese": "adigue; adigei",
    "Italian": "Adyghe, Adygei",
    "Spanish": "Adyghe ; Adygei",
    "Dutch": "Adygees"
  },
  {
    "alpha2": "afa",
    "English": "Afro-Asiatic languages",
    "French": "afro-asiatiques, langues",
    "German": "Afroasiatische Sprachen",
    "Portuguese": "Línguas afro-asiáticas",
    "Italian": "Afroasiatiche (Altre)",
    "Spanish": "Lenguas afroasiáticas",
    "Dutch": "Afro-Aziatische talen"
  },
  {
    "alpha2": "afh",
    "English": "Afrihili",
    "French": "afrihili",
    "German": "Afrihili",
    "Portuguese": "afrihili",
    "Italian": "Afrihili",
    "Spanish": "Afrihili",
    "Dutch": "Afrihili"
  },
  {
    "alpha2": "afr",
    "English": "Afrikaans",
    "French": "afrikaans",
    "German": "Afrikaans",
    "Portuguese": "africânder",
    "Italian": "Afrikaans",
    "Spanish": "africaans",
    "Dutch": "Afrikaans"
  },
  {
    "alpha2": "ain",
    "English": "Ainu",
    "French": "aïnou",
    "German": "Ainu-Sprache",
    "Portuguese": "aino",
    "Italian": "Ainu",
    "Spanish": "Ainu",
    "Dutch": "Ainu"
  },
  {
    "alpha2": "aka",
    "English": "Akan",
    "French": "akan",
    "German": "Akan-Sprache",
    "Portuguese": "Acã",
    "Italian": "Akan",
    "Spanish": "Akan",
    "Dutch": "Akan"
  },
  {
    "alpha2": "akk",
    "English": "Akkadian",
    "French": "akkadien",
    "German": "Akkadisch",
    "Portuguese": "acádio",
    "Italian": "Accadico",
    "Spanish": "Acadio",
    "Dutch": "Akkadisch"
  },
  {
    "alpha2": "ale",
    "English": "Aleut",
    "French": "aléoute",
    "German": "Aleutisch",
    "Portuguese": "aleúte",
    "Italian": "Aleutino",
    "Spanish": "Aleut",
    "Dutch": "Aleoets"
  },
  {
    "alpha2": "alg",
    "English": "Algonquian languages",
    "French": "algonquines, langues",
    "German": "Algonkin-Sprachen (Andere)",
    "Portuguese": "Línguas algonquinas",
    "Italian": "Lingue algonchine",
    "Spanish": "Lenguas algonquinas",
    "Dutch": "Algonkische talen"
  },
  {
    "alpha2": "alt",
    "English": "Southern Altai",
    "French": "altai du Sud",
    "German": "Altaisch",
    "Portuguese": "altai do sul",
    "Italian": "Altaiche (Altre)",
    "Spanish": "Altai meridional",
    "Dutch": "Zuid-Altaïsch"
  },
  {
    "alpha2": "amh",
    "English": "Amharic",
    "French": "amharique",
    "German": "Amharisch",
    "Portuguese": "amárico",
    "Italian": "Amarico",
    "Spanish": "Amárico",
    "Dutch": "Amhaars"
  },
  {
    "alpha2": "ang",
    "English": "English, Old (ca.450-1100)",
    "French": "anglo-saxon (ca.450-1100)",
    "German": "Altenglisch",
    "Portuguese": "inglês antigo (ca. 450-1100)",
    "Italian": "Inglese, Antico (ca. 450-1100)",
    "Spanish": "Inglés, antiguo (ca. 450-1100)",
    "Dutch": "Oudengels (ca. 450-1100)"
  },
  {
    "alpha2": "anp",
    "English": "Angika",
    "French": "angika",
    "German": "Anga-Sprache",
    "Portuguese": "Angika",
    "Spanish": "Angika",
    "Dutch": "Angika"
  },
  {
    "alpha2": "apa",
    "English": "Apache languages",
    "French": "apaches, langues",
    "German": "Apachen-Sprachen",
    "Portuguese": "Línguas apache",
    "Italian": "Lingue apache",
    "Spanish": "Idiomas apache",
    "Dutch": "Na-Denétalen"
  },
  {
    "alpha2": "ara",
    "English": "Arabic",
    "French": "arabe",
    "German": "Arabisch",
    "Portuguese": "árabe",
    "Italian": "Arabo",
    "Spanish": "Arábica",
    "Dutch": "Arabisch"
  },
  {
    "alpha2": "arc",
    "English": "Official Aramaic (700-300 BCE); Imperial Aramaic (700-300 BCE)",
    "French": "araméen d'empire (700-300 BCE)",
    "German": "Aramäisch",
    "Portuguese": "aramaico",
    "Italian": "Aramaico",
    "Spanish": "Arameo oficial (700–300 a. C.); Arameo imperial (700-300 a. C.)",
    "Dutch": "Aramees"
  },
  {
    "alpha2": "arg",
    "English": "Aragonese",
    "French": "aragonais",
    "German": "Aragonesisch",
    "Portuguese": "aragonês",
    "Italian": "Aragonese",
    "Spanish": "aragonés",
    "Dutch": "Aragonees"
  },
  {
    "alpha2": "arn",
    "English": "Mapudungun; Mapuche",
    "French": "mapudungun; mapuche; mapuce",
    "German": "Arauka-Sprachen",
    "Portuguese": "mapudungun; mapuche",
    "Italian": "Araucaniano, Mapudungun",
    "Spanish": "Mapudungun; Mapuche",
    "Dutch": "Mapudungun (Araukaans)"
  },
  {
    "alpha2": "arp",
    "English": "Arapaho",
    "French": "arapaho",
    "German": "Arapaho-Sprache",
    "Portuguese": "arapaho",
    "Italian": "Arapaho",
    "Spanish": "Arapaho",
    "Dutch": "Arapaho"
  },
  {
    "alpha2": "art",
    "English": "Artificial languages",
    "French": "artificielles, langues",
    "German": "Kunstsprachen (Andere)",
    "Portuguese": "Línguas artificiais",
    "Italian": "Lingua artificiale (Altre)",
    "Spanish": "Lenguajes artificiales",
    "Dutch": "Kunsttalen"
  },
  {
    "alpha2": "arw",
    "English": "Arawak",
    "French": "arawak",
    "German": "Arawak-Sprachen",
    "Portuguese": "aruaque",
    "Italian": "Arawak",
    "Spanish": "Arawak",
    "Dutch": "Arawak"
  },
  {
    "alpha2": "asm",
    "English": "Assamese",
    "French": "assamais",
    "German": "Assamesisch",
    "Portuguese": "assamês",
    "Italian": "Assamese",
    "Spanish": "Asamés",
    "Dutch": "Assamees"
  },
  {
    "alpha2": "ast",
    "English": "Asturian; Bable; Leonese; Asturleonese",
    "French": "asturien; bable; léonais; asturoléonais",
    "German": "Asturisch",
    "Portuguese": "asturiano; bable",
    "Italian": "Asturiano; Bable",
    "Spanish": "Asturiano ; Bable ; Leonés ; Asturleonés",
    "Dutch": "Asturisch"
  },
  {
    "alpha2": "ath",
    "English": "Athapascan languages",
    "French": "athapascanes, langues",
    "German": "Athapaskische Sprachen (Andere)",
    "Portuguese": "Línguas atabascanas",
    "Italian": "Lingue athabaska",
    "Spanish": "Lenguas atapascas",
    "Dutch": "Athabaskische talen"
  },
  {
    "alpha2": "aus",
    "English": "Australian languages",
    "French": "australiennes, langues",
    "German": "Australische Sprachen",
    "Portuguese": "Línguas australianas",
    "Italian": "Austronesiano (Altre)",
    "Spanish": "Lenguas australianas",
    "Dutch": "Australische talen"
  },
  {
    "alpha2": "ava",
    "English": "Avaric",
    "French": "avar",
    "German": "Awarisch",
    "Portuguese": "avárico",
    "Italian": "Avarico",
    "Spanish": "Avarico",
    "Dutch": "Avaars"
  },
  {
    "alpha2": "ave",
    "English": "Avestan",
    "French": "avestique",
    "German": "Avestisch",
    "Portuguese": "avéstico",
    "Italian": "Avestico",
    "Spanish": "Avestan",
    "Dutch": "Avestisch"
  },
  {
    "alpha2": "awa",
    "English": "Awadhi",
    "French": "awadhi",
    "German": "Awadhi",
    "Portuguese": "awadhi",
    "Italian": "Awadhi",
    "Spanish": "Awadhi",
    "Dutch": "Awadhi"
  },
  {
    "alpha2": "aym",
    "English": "Aymara",
    "French": "aymara",
    "German": "Aymará-Sprache",
    "Portuguese": "aimará",
    "Italian": "Aymara",
    "Spanish": "aimara",
    "Dutch": "Aymara"
  },
  {
    "alpha2": "aze",
    "English": "Azerbaijani",
    "French": "azéri",
    "German": "Aserbeidschanisch",
    "Portuguese": "azerbaijano",
    "Italian": "Azero",
    "Spanish": "Azerbaiyano",
    "Dutch": "Azerbeidzjaans"
  },
  {
    "alpha2": "bad",
    "English": "Banda languages",
    "French": "banda, langues",
    "German": "Banda-Sprachen (Ubangi-Sprachen)",
    "Portuguese": "banda",
    "Italian": "Banda",
    "Spanish": "Idiomas de banda",
    "Dutch": "Bandatalen (Centraal-Afrika)"
  },
  {
    "alpha2": "bai",
    "English": "Bamileke languages",
    "French": "bamiléké, langues",
    "German": "Bamileke-Sprachen",
    "Portuguese": "Línguas bamileke",
    "Italian": "Lingue bamileke",
    "Spanish": "Idiomas bamileke",
    "Dutch": "Bamileke"
  },
  {
    "alpha2": "bak",
    "English": "Bashkir",
    "French": "bachkir",
    "German": "Baschkirisch",
    "Portuguese": "basquir",
    "Italian": "Bashkir",
    "Spanish": "Bashkir",
    "Dutch": "Basjkiers"
  },
  {
    "alpha2": "bal",
    "English": "Baluchi",
    "French": "baloutchi",
    "German": "Belutschisch",
    "Portuguese": "balúchi",
    "Italian": "Baluchi",
    "Spanish": "Baluchi"
  },
  {
    "alpha2": "bam",
    "English": "Bambara",
    "French": "bambara",
    "German": "Bambara-Sprache",
    "Portuguese": "bâmbara",
    "Italian": "Bambara",
    "Spanish": "Bambara",
    "Dutch": "Bambara"
  },
  {
    "alpha2": "ban",
    "English": "Balinese",
    "French": "balinais",
    "German": "Balinesisch",
    "Portuguese": "balinês",
    "Italian": "Balinese",
    "Spanish": "Balinés",
    "Dutch": "Balinees"
  },
  {
    "alpha2": "bas",
    "English": "Basa",
    "French": "basa",
    "German": "Basaa-Sprache",
    "Portuguese": "basa",
    "Italian": "Basa",
    "Spanish": "Basa",
    "Dutch": "Basa"
  },
  {
    "alpha2": "bat",
    "English": "Baltic languages",
    "French": "baltes, langues",
    "German": "Baltische Sprachen (Andere)",
    "Portuguese": "Línguas bálticas",
    "Italian": "Lingue baltiche (Altre)",
    "Spanish": "Lenguas bálticas",
    "Dutch": "Baltische talen"
  },
  {
    "alpha2": "bej",
    "English": "Beja; Bedawiyet",
    "French": "bedja",
    "German": "Bedauye",
    "Portuguese": "beja",
    "Italian": "Beja",
    "Spanish": "Beja ; Bedawiyet",
    "Dutch": "Beja; Bedawi"
  },
  {
    "alpha2": "bel",
    "English": "Belarusian",
    "French": "biélorusse",
    "German": "Weißrussisch",
    "Portuguese": "bielorrusso",
    "Italian": "Bielorusso",
    "Spanish": "Bielorruso",
    "Dutch": "Wit-Russisch (Belarussisch)"
  },
  {
    "alpha2": "bem",
    "English": "Bemba",
    "French": "bemba",
    "German": "Bemba-Sprache",
    "Portuguese": "bemba",
    "Italian": "Bemba",
    "Spanish": "Bemba",
    "Dutch": "Bemba"
  },
  {
    "alpha2": "ben",
    "English": "Bengali",
    "French": "bengali",
    "German": "Bengali",
    "Portuguese": "bengali ou bangla",
    "Italian": "Bengali",
    "Spanish": "bengalí",
    "Dutch": "Bengaals"
  },
  {
    "alpha2": "ber",
    "English": "Berber languages",
    "French": "berbères, langues",
    "German": "Berbersprachen (Andere)",
    "Portuguese": "Línguas berberes",
    "Italian": "Lingue berbere",
    "Spanish": "Lenguas bereberes",
    "Dutch": "Berber"
  },
  {
    "alpha2": "bho",
    "English": "Bhojpuri",
    "French": "bhojpuri",
    "German": "Bhojpuri",
    "Portuguese": "boiapuri",
    "Italian": "Bhojpuri",
    "Spanish": "Bhojpuri",
    "Dutch": "Bhojpuri"
  },
  {
    "alpha2": "bih",
    "English": "Bihari languages",
    "French": "langues biharis",
    "German": "Bihari (Andere)",
    "Portuguese": "Línguas biaris",
    "Italian": "Bihari",
    "Spanish": "Idiomas bihari",
    "Dutch": "Bihari"
  },
  {
    "alpha2": "bik",
    "English": "Bikol",
    "French": "bikol",
    "German": "Bikol-Sprache",
    "Portuguese": "bikol",
    "Italian": "Bikol",
    "Spanish": "Bikol",
    "Dutch": "Bicol"
  },
  {
    "alpha2": "bin",
    "English": "Bini; Edo",
    "French": "bini; edo",
    "German": "Edo-Sprache",
    "Portuguese": "bini",
    "Italian": "Bini",
    "Spanish": "Bini ; Edo",
    "Dutch": "Edo (Bini)"
  },
  {
    "alpha2": "bis",
    "English": "Bislama",
    "French": "bichlamar",
    "German": "Beach-la-mar",
    "Portuguese": "bislamá bichlamar",
    "Italian": "Bislama",
    "Spanish": "Bislama",
    "Dutch": "Bislama"
  },
  {
    "alpha2": "bla",
    "English": "Siksika",
    "French": "blackfoot",
    "German": "Blackfoot-Sprache",
    "Portuguese": "siksika; blackfoot",
    "Italian": "Siksika",
    "Spanish": "Siksika",
    "Dutch": "Siksika (Blackfoot)"
  },
  {
    "alpha2": "bnt",
    "English": "Bantu languages",
    "French": "bantou, langues",
    "German": "Bantusprachen (Andere)",
    "Portuguese": "línguas bantas",
    "Italian": "Bantu (Altre)",
    "Spanish": "Lenguas bantúes",
    "Dutch": "Bantoetalen"
  },
  {
    "alpha2": "bod",
    "English": "Tibetan",
    "French": "tibétain",
    "German": "Tibetisch",
    "Portuguese": "tibetano",
    "Italian": "Tibetano",
    "Spanish": "Tibetano",
    "Dutch": "Tibetaans"
  },
  {
    "alpha2": "bos",
    "English": "Bosnian",
    "French": "bosniaque",
    "German": "Bosnisch",
    "Portuguese": "bósnio",
    "Italian": "Bosniaco",
    "Spanish": "bosnio",
    "Dutch": "Bosnisch"
  },
  {
    "alpha2": "bra",
    "English": "Braj",
    "French": "braj",
    "German": "Braj-Bhakha",
    "Portuguese": "braj",
    "Italian": "Braj",
    "Spanish": "Braj",
    "Dutch": "Braj"
  },
  {
    "alpha2": "bre",
    "English": "Breton",
    "French": "breton",
    "German": "Bretonisch",
    "Portuguese": "bretão",
    "Italian": "Bretone",
    "Spanish": "Bretón",
    "Dutch": "Bretons"
  },
  {
    "alpha2": "btk",
    "English": "Batak languages",
    "French": "batak, langues",
    "German": "Batak-Sprache",
    "Portuguese": "Línguas bataque (Indonesia)",
    "Italian": "Batak (Indonesia)",
    "Spanish": "Idiomas batak",
    "Dutch": "Bataktalen"
  },
  {
    "alpha2": "bua",
    "English": "Buriat",
    "French": "bouriate",
    "German": "Burjatisch",
    "Portuguese": "buriat",
    "Italian": "Buriato",
    "Spanish": "Buriat",
    "Dutch": "Boerjatisch"
  },
  {
    "alpha2": "bug",
    "English": "Buginese",
    "French": "bugi",
    "German": "Bugi-Sprache",
    "Portuguese": "buginês",
    "Italian": "Buginese",
    "Spanish": "Buginés",
    "Dutch": "Buginees"
  },
  {
    "alpha2": "bul",
    "English": "Bulgarian",
    "French": "bulgare",
    "German": "Bulgarisch",
    "Portuguese": "búlgaro",
    "Italian": "Bulgaro",
    "Spanish": "búlgaro",
    "Dutch": "Bulgaars"
  },
  {
    "alpha2": "byn",
    "English": "Blin; Bilin",
    "French": "blin; bilen",
    "German": "Bilin-Sprache",
    "Portuguese": "blin; bilin",
    "Italian": "Blin; Bilin",
    "Spanish": "Blin; Bilin",
    "Dutch": "Blin; Bilin"
  },
  {
    "alpha2": "cad",
    "English": "Caddo",
    "French": "caddo",
    "German": "Caddo-Sprachen",
    "Portuguese": "caddo",
    "Italian": "Caddo",
    "Spanish": "Caddo",
    "Dutch": "Caddo"
  },
  {
    "alpha2": "cai",
    "English": "Central American Indian languages",
    "French": "amérindiennes de l'Amérique centrale, langues",
    "German": "Indianersprachen, Zentralamerika (Andere)",
    "Portuguese": "Outras línguas indígenas da América Central",
    "Italian": "Indiane centro-americane (Altre)",
    "Spanish": "Idiomas de los indios centroamericanos",
    "Dutch": "Midden-Amerikaanse Indiaanse talen"
  },
  {
    "alpha2": "car",
    "English": "Galibi Carib",
    "French": "karib; galibi; carib",
    "German": "Karibische Sprachen",
    "Portuguese": "caribe",
    "Italian": "Caribe",
    "Spanish": "Galibi Carib",
    "Dutch": "Caribische talen"
  },
  {
    "alpha2": "cat",
    "English": "Catalan; Valencian",
    "French": "catalan; valencien",
    "German": "Katalanisch",
    "Portuguese": "catalão",
    "Italian": "Catalano; Valenciano",
    "Spanish": "Catalán ; valenciano",
    "Dutch": "Catalaans"
  },
  {
    "alpha2": "cau",
    "English": "Caucasian languages",
    "French": "caucasiennes, langues",
    "German": "Kaukasische Sprachen (Andere)",
    "Portuguese": "cáucaso (Outras)",
    "Italian": "Lingue caucasiche (Altre)",
    "Spanish": "Lenguas caucásicas",
    "Dutch": "Kaukasische talen"
  },
  {
    "alpha2": "ceb",
    "English": "Cebuano",
    "French": "cebuano",
    "German": "Cebuano",
    "Portuguese": "cebuano",
    "Italian": "Cebuano",
    "Spanish": "Cebuano",
    "Dutch": "Cebuano"
  },
  {
    "alpha2": "cel",
    "English": "Celtic languages",
    "French": "celtiques, langues; celtes, langues",
    "German": "Keltische Sprachen (Andere)",
    "Portuguese": "céltico (Outras)",
    "Italian": "Lingue celtiche (Altre)",
    "Spanish": "Lenguas celtas",
    "Dutch": "Keltische talen"
  },
  {
    "alpha2": "ces",
    "English": "Czech",
    "French": "tchèque",
    "German": "Tschechisch",
    "Portuguese": "tcheco",
    "Italian": "Ceco",
    "Spanish": "checo",
    "Dutch": "Tsjechisch"
  },
  {
    "alpha2": "cha",
    "English": "Chamorro",
    "French": "chamorro",
    "German": "Chamorro-Sprache",
    "Portuguese": "chamorro",
    "Italian": "Chamorro",
    "Spanish": "Chamorro",
    "Dutch": "Chamorro"
  },
  {
    "alpha2": "chb",
    "English": "Chibcha",
    "French": "chibcha",
    "German": "Chibcha-Sprachen",
    "Portuguese": "chibcha",
    "Italian": "Chibcha",
    "Spanish": "Chibcha",
    "Dutch": "Chibcha"
  },
  {
    "alpha2": "che",
    "English": "Chechen",
    "French": "tchétchène",
    "German": "Tschetschenisch",
    "Portuguese": "tchecheno ou checheno",
    "Italian": "Ceceno",
    "Spanish": "Checheno",
    "Dutch": "Tsjetsjeens"
  },
  {
    "alpha2": "chg",
    "English": "Chagatai",
    "French": "djaghataï",
    "German": "Tschagataisch",
    "Portuguese": "chagatai",
    "Italian": "Chagatai",
    "Spanish": "Chagatai",
    "Dutch": "Chagatai (Tsjagatai)"
  },
  {
    "alpha2": "chk",
    "English": "Chuukese",
    "French": "chuuk",
    "German": "Trukesisch",
    "Portuguese": "chuukês; truquês",
    "Italian": "Chuukese",
    "Spanish": "Chuukese",
    "Dutch": "Chuukees"
  },
  {
    "alpha2": "chm",
    "English": "Mari",
    "French": "mari",
    "German": "Mari",
    "Portuguese": "mari",
    "Italian": "Mari",
    "Spanish": "Mari",
    "Dutch": "Mari"
  },
  {
    "alpha2": "chn",
    "English": "Chinook jargon",
    "French": "chinook, jargon",
    "German": "Chinook-Jargon",
    "Portuguese": "jargão chinook",
    "Italian": "Chinook jargon",
    "Spanish": "Jerga chinook",
    "Dutch": "Chinook"
  },
  {
    "alpha2": "cho",
    "English": "Choctaw",
    "French": "choctaw",
    "German": "Choctaw-Sprache",
    "Portuguese": "choctaw",
    "Italian": "Choctaw",
    "Spanish": "Choctaw",
    "Dutch": "Choctaw"
  },
  {
    "alpha2": "chp",
    "English": "Chipewyan; Dene Suline",
    "French": "chipewyan",
    "German": "Chipewyan-Sprache",
    "Portuguese": "chipewyan",
    "Italian": "Chipewyan",
    "Spanish": "Chipewyan ; Dene Suline",
    "Dutch": "Chipewyan"
  },
  {
    "alpha2": "chr",
    "English": "Cherokee",
    "French": "cherokee",
    "German": "Cherokee-Sprache",
    "Portuguese": "cherokee",
    "Italian": "Cherokee",
    "Spanish": "Cherokee",
    "Dutch": "Cherokee"
  },
  {
    "alpha2": "chu",
    "English": "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic",
    "French": "slavon d'église; vieux slave; slavon liturgique; vieux bulgare",
    "German": "Kirchenslawisch",
    "Portuguese": "eslavo eclesiástico; eslavo antigo; búlgaro antigo",
    "Italian": "Antico slavo ecclesiastico",
    "Spanish": "Eslavo eclesiástico ; Eslavo antiguo ; Eslavo eclesiástico ; Viejo búlgaro ; Antiguo eslavo eclesiástico",
    "Dutch": "Kerkslavisch"
  },
  {
    "alpha2": "chv",
    "English": "Chuvash",
    "French": "tchouvache",
    "German": "Tschuwaschisch",
    "Portuguese": "tchuvache",
    "Italian": "Ciuvascio",
    "Spanish": "Chuvash",
    "Dutch": "Tsjoevasjisch"
  },
  {
    "alpha2": "chy",
    "English": "Cheyenne",
    "French": "cheyenne",
    "German": "Cheyenne-Sprache",
    "Portuguese": "cheyenne",
    "Italian": "Cheyenne",
    "Spanish": "Cheyenne",
    "Dutch": "Cheyenne"
  },
  {
    "alpha2": "cmc",
    "English": "Chamic languages",
    "French": "chames, langues",
    "German": "Cham-Sprachen",
    "Portuguese": "chamic",
    "Italian": "Chamic",
    "Spanish": "Lenguas chamicas",
    "Dutch": "Chamische talen"
  },
  {
    "alpha2": "cnr",
    "English": "Montenegrin",
    "French": "monténégrin",
    "German": "Montenegrinisch",
    "Spanish": "montenegrino"
  },
  {
    "alpha2": "cop",
    "English": "Coptic",
    "French": "copte",
    "German": "Koptisch",
    "Portuguese": "copto",
    "Italian": "Copto",
    "Spanish": "copto",
    "Dutch": "Koptisch"
  },
  {
    "alpha2": "cor",
    "English": "Cornish",
    "French": "cornique",
    "German": "Kornisch",
    "Portuguese": "córnico",
    "Italian": "Cornico",
    "Spanish": "de Cornualles",
    "Dutch": "Cornisch"
  },
  {
    "alpha2": "cos",
    "English": "Corsican",
    "French": "corse",
    "German": "Korsisch",
    "Portuguese": "corso",
    "Italian": "Corso",
    "Spanish": "corso",
    "Dutch": "Corsicaans"
  },
  {
    "alpha2": "cpe",
    "English": "Creoles and pidgins, English based",
    "French": "créoles et pidgins basés sur l'anglais",
    "German": "Kreolisch-Englisch (Andere)",
    "Italian": "Creoli e Pidgin basati sull'inglese (Altre)",
    "Spanish": "Criollos y pidgins , basados ​​en inglés",
    "Dutch": "Engelse creoolse talen"
  },
  {
    "alpha2": "cpf",
    "English": "Creoles and pidgins, French-based",
    "French": "créoles et pidgins basés sur le français",
    "German": "Kreolisch-Französisch (Andere)",
    "Italian": "Creoli e Pidgin basati sul francese (Altre)",
    "Spanish": "Criollos y pidgins, basados ​​en francés",
    "Dutch": "Franse creoolse talen (overige)"
  },
  {
    "alpha2": "cpp",
    "English": "Creoles and pidgins, Portuguese-based",
    "French": "créoles et pidgins basés sur le portugais",
    "German": "Kreolisch-Portugiesisch (Andere)",
    "Italian": "Creoli e Pidgin basati sul portoghese (Altre)",
    "Spanish": "Criollos y pidgins, basados ​​en portugués",
    "Dutch": "Portugese creoolse talen (overige)"
  },
  {
    "alpha2": "cre",
    "English": "Cree",
    "French": "cree",
    "German": "Cree-Sprache",
    "Portuguese": "cree",
    "Italian": "Cree",
    "Spanish": "Cree",
    "Dutch": "Cree"
  },
  {
    "alpha2": "crh",
    "English": "Crimean Tatar; Crimean Turkish",
    "French": "tatar de Crimé",
    "German": "Krimtatarisch",
    "Portuguese": "tártaro da Crimeia",
    "Italian": "Crimean Tatar; Crimean Turkish",
    "Spanish": "Tártaro de Crimea ; Turco de Crimea",
    "Dutch": "Krim-Tataars"
  },
  {
    "alpha2": "crp",
    "English": "Creoles and pidgins",
    "French": "créoles et pidgins",
    "German": "Kreolische Sprachen; Pidginsprachen (Andere)",
    "Portuguese": "Creoles and Pidgins (Outras)",
    "Italian": "Creoli e Pidgin (Altre)",
    "Spanish": "Criollos y pidgins",
    "Dutch": "Creools en Pidgin (overige)"
  },
  {
    "alpha2": "csb",
    "English": "Kashubian",
    "French": "kachoube",
    "German": "Kaschubisch",
    "Portuguese": "cassúbio; caxubo",
    "Italian": "Casciubo",
    "Spanish": "Casubio",
    "Dutch": "Kasjoebisch"
  },
  {
    "alpha2": "cus",
    "English": "Cushitic languages",
    "French": "couchitiques, langues",
    "German": "Kuschitische Sprachen (Andere)",
    "Portuguese": "Línguas cuchíticas (Outras)",
    "Italian": "Lingue cushitiche (Altre)",
    "Spanish": "Lenguas cusíticas",
    "Dutch": "Koesjitische talen (overige)"
  },
  {
    "alpha2": "cym",
    "English": "Welsh",
    "French": "gallois",
    "German": "Walisisch",
    "Portuguese": "galês",
    "Italian": "Gallese",
    "Spanish": "galés",
    "Dutch": "Welsh"
  },
  {
    "alpha2": "dak",
    "English": "Dakota",
    "French": "dakota",
    "German": "Dakota-Sprache",
    "Portuguese": "dacota",
    "Italian": "Dakota",
    "Spanish": "Dakota",
    "Dutch": "Dakota"
  },
  {
    "alpha2": "dan",
    "English": "Danish",
    "French": "danois",
    "German": "Dänisch",
    "Portuguese": "dinamarquês",
    "Italian": "Danese",
    "Spanish": "danés",
    "Dutch": "Deens"
  },
  {
    "alpha2": "dar",
    "English": "Dargwa",
    "French": "dargwa",
    "German": "Darginisch",
    "Portuguese": "dargínico",
    "Italian": "Dargwa",
    "Spanish": "Dargwa",
    "Dutch": "Darginisch (Dargwa)"
  },
  {
    "alpha2": "day",
    "English": "Land Dayak languages",
    "French": "dayak, langues",
    "German": "Dajakisch",
    "Portuguese": "dayak",
    "Italian": "Dayak",
    "Spanish": "Idiomas de Land Dayak",
    "Dutch": "Dajaktalen"
  },
  {
    "alpha2": "del",
    "English": "Delaware",
    "French": "delaware",
    "German": "Delaware-Sprache",
    "Portuguese": "delaware",
    "Italian": "Delaware",
    "Spanish": "Delaware",
    "Dutch": "Unami (Delaware)"
  },
  {
    "alpha2": "den",
    "English": "Slave (Athapascan)",
    "French": "esclave (athapascan)",
    "German": "Slave-Sprache",
    "Portuguese": "slave (athapascano)",
    "Italian": "Slave (Athabascan)",
    "Spanish": "Esclavo (Athapascan)",
    "Dutch": "Slavey"
  },
  {
    "alpha2": "deu",
    "English": "German",
    "French": "allemand",
    "German": "Deutsch",
    "Portuguese": "alemão",
    "Italian": "Tedesco",
    "Spanish": "alemán",
    "Dutch": "Duits"
  },
  {
    "alpha2": "dgr",
    "English": "Dogrib",
    "French": "dogrib",
    "German": "Dogrib-Sprache",
    "Portuguese": "dogrib",
    "Italian": "Dogrib",
    "Spanish": "Dogrib",
    "Dutch": "Dogrib"
  },
  {
    "alpha2": "din",
    "English": "Dinka",
    "French": "dinka",
    "German": "Dinka-Sprache",
    "Portuguese": "dinka",
    "Italian": "Dinka",
    "Spanish": "Dinka",
    "Dutch": "Dinka (Thuongjang)"
  },
  {
    "alpha2": "div",
    "English": "Divehi; Dhivehi; Maldivian",
    "French": "maldivien",
    "German": "Maledivisch",
    "Portuguese": "divehi; maldívio",
    "Italian": "Divehi",
    "Spanish": "Divehi; Dhivehi; Maldivas",
    "Dutch": "Divehi"
  },
  {
    "alpha2": "doi",
    "English": "Dogri",
    "French": "dogri",
    "German": "Dogri",
    "Portuguese": "dogri",
    "Italian": "Dogri",
    "Spanish": "Dogri",
    "Dutch": "Dogri"
  },
  {
    "alpha2": "dra",
    "English": "Dravidian languages",
    "French": "dravidiennes, langues",
    "German": "Drawidische Sprachen (Andere)",
    "Portuguese": "dravidiano (Outras)",
    "Italian": "Dravidiche (Altre)",
    "Spanish": "Lenguas dravídicas",
    "Dutch": "Dravidische talen (overige)"
  },
  {
    "alpha2": "dsb",
    "English": "Lower Sorbian",
    "French": "bas-sorabe",
    "German": "Niedersorbisch",
    "Portuguese": "baixo sorábio",
    "Italian": "Lusaziano inferiore",
    "Spanish": "Bajo sorabo",
    "Dutch": "Nedersorbisch"
  },
  {
    "alpha2": "dua",
    "English": "Duala",
    "French": "douala",
    "German": "Duala-Sprachen",
    "Portuguese": "duala",
    "Italian": "Duala",
    "Spanish": "Duala",
    "Dutch": "Duala"
  },
  {
    "alpha2": "dum",
    "English": "Dutch, Middle (ca.1050-1350)",
    "French": "néerlandais moyen (ca. 1050-1350)",
    "German": "Mittelniederländisch",
    "Portuguese": "holandês médio (ca. 1050-1350)",
    "Italian": "Medio olandese (ca. 1050-1350)",
    "Spanish": "Holandés, medio (ca. 1050-1350)",
    "Dutch": "Middelnederlands (ca.1050-1350)"
  },
  {
    "alpha2": "dyu",
    "English": "Dyula",
    "French": "dioula",
    "German": "Dyula-Sprache",
    "Portuguese": "dyula",
    "Italian": "Dyula",
    "Spanish": "Dyula",
    "Dutch": "Dioula"
  },
  {
    "alpha2": "dzo",
    "English": "Dzongkha",
    "French": "dzongkha",
    "German": "Dzongkha",
    "Portuguese": "dzongkha; zoncá",
    "Italian": "Dzongkha",
    "Spanish": "Dzongkha",
    "Dutch": "Dzongkha"
  },
  {
    "alpha2": "efi",
    "English": "Efik",
    "French": "efik",
    "German": "Efik",
    "Portuguese": "efique",
    "Italian": "Efik",
    "Spanish": "Efik",
    "Dutch": "Efik"
  },
  {
    "alpha2": "egy",
    "English": "Egyptian (Ancient)",
    "French": "égyptien",
    "German": "Ägyptisch",
    "Portuguese": "egípcio antigo",
    "Italian": "Egiziano, Antico",
    "Spanish": "Egipcio (antiguo)",
    "Dutch": "Oudegyptisch"
  },
  {
    "alpha2": "eka",
    "English": "Ekajuk",
    "French": "ekajuk",
    "German": "Ekajuk",
    "Portuguese": "ekajuk",
    "Italian": "Ekajuk, Akajo, Akajuk",
    "Spanish": "Ekajuk",
    "Dutch": "Ekajuk"
  },
  {
    "alpha2": "ell",
    "English": "Greek, Modern (1453-)",
    "French": "grec moderne (après 1453)",
    "German": "Neugriechisch",
    "Portuguese": "grego moderno (desde 1453)",
    "Italian": "Greco moderno (dal 1453)",
    "Spanish": "Griego, moderno (1453–)",
    "Dutch": "Grieks"
  },
  {
    "alpha2": "elx",
    "English": "Elamite",
    "French": "élamite",
    "German": "Elamisch",
    "Portuguese": "elemita",
    "Italian": "Elamitica",
    "Spanish": "Elamite",
    "Dutch": "Elamitisch"
  },
  {
    "alpha2": "eng",
    "English": "English",
    "French": "anglais",
    "German": "Englisch",
    "Portuguese": "inglês",
    "Italian": "Inglese",
    "Spanish": "inglés",
    "Dutch": "Engels"
  },
  {
    "alpha2": "enm",
    "English": "English, Middle (1100-1500)",
    "French": "anglais moyen (1100-1500)",
    "German": "Mittelenglisch",
    "Portuguese": "inglês médio (ca. 1100-1500)",
    "Italian": "Inglese, Medio (ca. 1100-1500)",
    "Spanish": "Inglés, medio (1100-1500)",
    "Dutch": "Middelengels (1100-1500)"
  },
  {
    "alpha2": "epo",
    "English": "Esperanto",
    "French": "espéranto",
    "German": "Esperanto",
    "Portuguese": "esperanto",
    "Italian": "Esperanto",
    "Spanish": "esperanto",
    "Dutch": "Esperanto"
  },
  {
    "alpha2": "est",
    "English": "Estonian",
    "French": "estonien",
    "German": "Estnisch",
    "Portuguese": "estoniano",
    "Italian": "Estone",
    "Spanish": "Estonio",
    "Dutch": "Estisch"
  },
  {
    "alpha2": "eus",
    "English": "Basque",
    "French": "basque",
    "German": "Baskisch",
    "Portuguese": "basco",
    "Italian": "Basco",
    "Spanish": "vasco",
    "Dutch": "Baskisch"
  },
  {
    "alpha2": "ewe",
    "English": "Ewe",
    "French": "éwé",
    "German": "Ewe-Sprache",
    "Portuguese": "jeje",
    "Italian": "Ewe",
    "Spanish": "Oveja",
    "Dutch": "Ewe"
  },
  {
    "alpha2": "ewo",
    "English": "Ewondo",
    "French": "éwondo",
    "German": "Ewondo",
    "Portuguese": "ewondo",
    "Italian": "Ewondo",
    "Spanish": "Ewondo",
    "Dutch": "Ewondo"
  },
  {
    "alpha2": "fan",
    "English": "Fang",
    "French": "fang",
    "German": "Fang",
    "Portuguese": "fang",
    "Italian": "Fang",
    "Spanish": "Colmillo",
    "Dutch": "Fang"
  },
  {
    "alpha2": "fao",
    "English": "Faroese",
    "French": "féroïen",
    "German": "Färöisch",
    "Portuguese": "feroês ou feróico",
    "Italian": "Faroese",
    "Spanish": "Feroés",
    "Dutch": "Faeröers"
  },
  {
    "alpha2": "fas",
    "English": "Persian",
    "French": "persan",
    "German": "Persisch",
    "Portuguese": "persa",
    "Italian": "Persiano",
    "Spanish": "persa",
    "Dutch": "Perzisch (Farsi)"
  },
  {
    "alpha2": "fat",
    "English": "Fanti",
    "French": "fanti",
    "German": "Fante-Sprache",
    "Portuguese": "fanti",
    "Italian": "Fanti",
    "Spanish": "Fanti",
    "Dutch": "Fante"
  },
  {
    "alpha2": "fij",
    "English": "Fijian",
    "French": "fidjien",
    "German": "Fidschi-Sprache",
    "Portuguese": "fidjiano",
    "Italian": "Fijiano",
    "Spanish": "Fiyiano",
    "Dutch": "Fijisch"
  },
  {
    "alpha2": "fil",
    "English": "Filipino; Pilipino",
    "French": "filipino; pilipino",
    "German": "Pilipino",
    "Portuguese": "filipino",
    "Italian": "Filippino",
    "Spanish": "filipina ; Pilipino",
    "Dutch": "Filipijns"
  },
  {
    "alpha2": "fin",
    "English": "Finnish",
    "French": "finnois",
    "German": "Finnisch",
    "Portuguese": "finlandês",
    "Italian": "Finlandese",
    "Spanish": "finlandés",
    "Dutch": "Fins"
  },
  {
    "alpha2": "fiu",
    "English": "Finno-Ugrian languages",
    "French": "finno-ougriennes, langues",
    "German": "Finnougrische Sprachen (Andere)",
    "Portuguese": "Línguas fino-úgricas (Outras)",
    "Italian": "Ugrofinniche (Altre)",
    "Spanish": "Lenguas finno-ugrianas",
    "Dutch": "Fins-Oegrische talen (overige)"
  },
  {
    "alpha2": "fon",
    "English": "Fon",
    "French": "fon",
    "German": "Fon-Sprache",
    "Portuguese": "fom",
    "Italian": "Fon",
    "Spanish": "Fon",
    "Dutch": "Fon"
  },
  {
    "alpha2": "fra",
    "English": "French",
    "French": "français",
    "German": "Französisch",
    "Portuguese": "francês",
    "Italian": "Francese",
    "Spanish": "francés",
    "Dutch": "Frans"
  },
  {
    "alpha2": "frm",
    "English": "French, Middle (ca.1400-1600)",
    "French": "français moyen (1400-1600)",
    "German": "Mittelfranzösisch",
    "Portuguese": "francês médio (ca. 1400-1600)",
    "Italian": "Francese, Medio (ca. 1400-1600)",
    "Spanish": "Francés, medio (ca. 1400-1600)",
    "Dutch": "Middelfrans (ca.1400-1600)"
  },
  {
    "alpha2": "fro",
    "English": "French, Old (842-ca.1400)",
    "French": "français ancien (842-ca.1400)",
    "German": "Altfranzösisch",
    "Portuguese": "francês antigo (842-ca. 1400)",
    "Italian": "Francese, Antico (842-ca. 1400)",
    "Spanish": "Francés, antiguo (842 – ca. 1400)",
    "Dutch": "Oudfrans (842-ca.1400)"
  },
  {
    "alpha2": "frr",
    "English": "Northern Frisian",
    "French": "frison septentrional",
    "German": "Nordfriesisch",
    "Portuguese": "frisão setentrional",
    "Spanish": "Frisón del norte",
    "Dutch": "Noord-Fries"
  },
  {
    "alpha2": "frs",
    "English": "Eastern Frisian",
    "French": "frison oriental",
    "German": "Ostfriesisch",
    "Portuguese": "frisão oriental",
    "Spanish": "Frisia Oriental Baja Sajona",
    "Dutch": "Oosterlauwers Fries"
  },
  {
    "alpha2": "fry",
    "English": "Western Frisian",
    "French": "frison occidental",
    "German": "Friesisch",
    "Portuguese": "frisão ocidental",
    "Italian": "Frisone occidentale",
    "Spanish": "Frisón occidental",
    "Dutch": "Westerlauwers Fries"
  },
  {
    "alpha2": "ful",
    "English": "Fulah",
    "French": "peul",
    "German": "Ful",
    "Portuguese": "fula",
    "Italian": "Fula",
    "Spanish": "Fulah",
    "Dutch": "Fula"
  },
  {
    "alpha2": "fur",
    "English": "Friulian",
    "French": "frioulan",
    "German": "Friulisch",
    "Portuguese": "friuliano",
    "Italian": "Friulano",
    "Spanish": "Friulano",
    "Dutch": "Friulisch"
  },
  {
    "alpha2": "gaa",
    "English": "Ga",
    "French": "ga",
    "German": "Ga-Sprache",
    "Portuguese": "ga",
    "Italian": "Ga",
    "Spanish": "Georgia",
    "Dutch": "Ga"
  },
  {
    "alpha2": "gay",
    "English": "Gayo",
    "French": "gayo",
    "German": "Gayo-Sprache",
    "Portuguese": "gayo",
    "Italian": "Gayo",
    "Spanish": "Gayo",
    "Dutch": "Gajo"
  },
  {
    "alpha2": "gba",
    "English": "Gbaya",
    "French": "gbaya",
    "German": "Gbaya-Sprache",
    "Portuguese": "gbaya",
    "Italian": "Gbaya",
    "Spanish": "Gbaya",
    "Dutch": "Gbaya"
  },
  {
    "alpha2": "gem",
    "English": "Germanic languages",
    "French": "germaniques, langues",
    "German": "Germanische Sprachen (Andere)",
    "Portuguese": "Outras línguas germânicas",
    "Italian": "Lingue germaniche (Altre)",
    "Spanish": "Lenguas germánicas",
    "Dutch": "Germaanse talen"
  },
  {
    "alpha2": "gez",
    "English": "Geez",
    "French": "guèze",
    "German": "Altäthiopisch",
    "Portuguese": "ge'ez",
    "Italian": "Geez",
    "Spanish": "Caray",
    "Dutch": "Ge'ez"
  },
  {
    "alpha2": "gil",
    "English": "Gilbertese",
    "French": "kiribati",
    "German": "Gilbertesisch",
    "Portuguese": "gilbertês; kiribati",
    "Italian": "Lingua gilbertese; Kiribati",
    "Spanish": "Gilbertese",
    "Dutch": "Kiribatisch (Gilbertees)"
  },
  {
    "alpha2": "gla",
    "English": "Gaelic; Scottish Gaelic",
    "French": "gaélique; gaélique écossais",
    "German": "Gälisch-Schottisch",
    "Portuguese": "gaélico escocês",
    "Italian": "Gaelico scozzese",
    "Spanish": "Gaélico ; gaélico escocés",
    "Dutch": "Schots-Gaelisch"
  },
  {
    "alpha2": "gle",
    "English": "Irish",
    "French": "irlandais",
    "German": "Irisch",
    "Portuguese": "irlandês",
    "Italian": "Gaelico irlandese",
    "Spanish": "irlandesa",
    "Dutch": "Iers"
  },
  {
    "alpha2": "glg",
    "English": "Galician",
    "French": "galicien",
    "German": "Galicisch",
    "Portuguese": "galego",
    "Italian": "Galiziano",
    "Spanish": "gallego",
    "Dutch": "Galicisch"
  },
  {
    "alpha2": "glv",
    "English": "Manx",
    "French": "manx; mannois",
    "German": "Manx",
    "Portuguese": "manês; manx",
    "Italian": "Mannese",
    "Spanish": "de la isla de Man",
    "Dutch": "Manx-Gaelisch"
  },
  {
    "alpha2": "gmh",
    "English": "German, Middle High (ca.1050-1500)",
    "French": "allemand, moyen haut (ca. 1050-1500)",
    "German": "Mittelhochdeutsch",
    "Portuguese": "alto-alemão médio (ca. 1050-1500)",
    "Italian": "Alto tedesco medio (ca. 1050-1500)",
    "Spanish": "Alemán, medio alto (ca. 1050-1500)",
    "Dutch": "Middelhoogduits (ca.1050-1500)"
  },
  {
    "alpha2": "goh",
    "English": "German, Old High (ca.750-1050)",
    "French": "allemand, vieux haut (ca. 750-1050)",
    "German": "Althochdeutsch",
    "Portuguese": "alto-alemão antigo (ca. 750-1050)",
    "Italian": "Alto tedesco antico (ca. 750-1050)",
    "Spanish": "Alemán, Antiguo Alto (ca. 750-1050)",
    "Dutch": "Oudhoogduits (ca.750-1050)"
  },
  {
    "alpha2": "gon",
    "English": "Gondi",
    "French": "gond",
    "German": "Gondi-Sprache",
    "Portuguese": "gondi",
    "Italian": "Gondi",
    "Spanish": "Gondi",
    "Dutch": "Gondi"
  },
  {
    "alpha2": "gor",
    "English": "Gorontalo",
    "French": "gorontalo",
    "German": "Gorontalesisch",
    "Portuguese": "gorontalo",
    "Italian": "Gorontalo",
    "Spanish": "Gorontalo",
    "Dutch": "Gorontalo"
  },
  {
    "alpha2": "got",
    "English": "Gothic",
    "French": "gothique",
    "German": "Gotisch",
    "Portuguese": "gótico",
    "Italian": "Gotico",
    "Spanish": "gótico",
    "Dutch": "Gotisch"
  },
  {
    "alpha2": "grb",
    "English": "Grebo",
    "French": "grebo",
    "German": "Grebo-Sprache",
    "Portuguese": "grebo",
    "Italian": "Grebo",
    "Spanish": "Grebo",
    "Dutch": "Grebo"
  },
  {
    "alpha2": "grc",
    "English": "Greek, Ancient (to 1453)",
    "French": "grec ancien (jusqu'à 1453)",
    "German": "Griechisch",
    "Portuguese": "grego antigo (até 1453)",
    "Italian": "Greco antico (fino al 1453)",
    "Spanish": "Griego, Antiguo (hasta 1453)",
    "Dutch": "Oudgrieks (tot 1453)"
  },
  {
    "alpha2": "grn",
    "English": "Guarani",
    "French": "guarani",
    "German": "Guaraní-Sprache",
    "Portuguese": "guarani",
    "Italian": "Guarani",
    "Spanish": "Guaraní",
    "Dutch": "Guaraní"
  },
  {
    "alpha2": "gsw",
    "English": "Swiss German; Alemannic; Alsatian",
    "French": "suisse alémanique; alémanique; alsacien",
    "German": "Schweizerdeutsch",
    "Portuguese": "suíço-alemão, alemânico, alsaciano",
    "Spanish": "Alemán suizo ; Alemannic ; alsaciano",
    "Dutch": "Zwitserduits"
  },
  {
    "alpha2": "guj",
    "English": "Gujarati",
    "French": "goudjrati",
    "German": "Gujarati-Sprache",
    "Portuguese": "gujarati; guzerate",
    "Italian": "Gujarati",
    "Spanish": "Gujarati",
    "Dutch": "Gujarati"
  },
  {
    "alpha2": "gwi",
    "English": "Gwich'in",
    "French": "gwich'in",
    "German": "Gwich'in (Sprache)",
    "Portuguese": "gwich´in",
    "Italian": "Gwich'in",
    "Spanish": "Gwich'in",
    "Dutch": "Gwich’in"
  },
  {
    "alpha2": "hai",
    "English": "Haida",
    "French": "haida",
    "German": "Haida-Sprache",
    "Portuguese": "haida",
    "Italian": "Haida",
    "Spanish": "Haida",
    "Dutch": "Haida"
  },
  {
    "alpha2": "hat",
    "English": "Haitian; Haitian Creole",
    "French": "haïtien; créole haïtien",
    "German": "Haïtien (Haiti-Kreolisch)",
    "Portuguese": "crioulo haitiano; Haitian",
    "Italian": "Creolo haitiano; Haitiano",
    "Spanish": "Haitiano; Criollo haitiano",
    "Dutch": "Haïtiaans Creools"
  },
  {
    "alpha2": "hau",
    "English": "Hausa",
    "French": "haoussa",
    "German": "Haussa-Sprache",
    "Portuguese": "Hauçá",
    "Italian": "Hausa",
    "Spanish": "Hausa",
    "Dutch": "Hausa"
  },
  {
    "alpha2": "haw",
    "English": "Hawaiian",
    "French": "hawaïen",
    "German": "Hawaiisch",
    "Portuguese": "havaiano",
    "Italian": "Hawaiano",
    "Spanish": "hawaiano",
    "Dutch": "Hawaïaans"
  },
  {
    "alpha2": "heb",
    "English": "Hebrew",
    "French": "hébreu",
    "German": "Hebräisch",
    "Portuguese": "hebraico",
    "Italian": "Ebraico",
    "Spanish": "hebreo",
    "Dutch": "Hebreeuws"
  },
  {
    "alpha2": "her",
    "English": "Herero",
    "French": "herero",
    "German": "Herero-Sprache",
    "Portuguese": "hereró",
    "Italian": "Herero",
    "Spanish": "Herero",
    "Dutch": "Herero"
  },
  {
    "alpha2": "hil",
    "English": "Hiligaynon",
    "French": "hiligaynon",
    "German": "Hiligaynon-Sprache",
    "Portuguese": "hiligaynon",
    "Italian": "Hiligaynon",
    "Spanish": "Hiligaynon",
    "Dutch": "Hiligaynon"
  },
  {
    "alpha2": "him",
    "English": "Himachali languages; Western Pahari languages",
    "French": "langues himachalis; langues paharis occidentales",
    "German": "Himachali",
    "Portuguese": "himachali",
    "Italian": "Himachali",
    "Spanish": "Lenguas Himachali; Idiomas Pahari",
    "Dutch": "Himachali"
  },
  {
    "alpha2": "hin",
    "English": "Hindi",
    "French": "hindi",
    "German": "Hindi",
    "Portuguese": "hindi; híndi; indi",
    "Italian": "Hindi",
    "Spanish": "hindi",
    "Dutch": "Hindi"
  },
  {
    "alpha2": "hit",
    "English": "Hittite",
    "French": "hittite",
    "German": "Hethitisch",
    "Portuguese": "hitita",
    "Italian": "Nesiano, Ittita",
    "Spanish": "hitita",
    "Dutch": "Hettitisch"
  },
  {
    "alpha2": "hmn",
    "English": "Hmong; Mong",
    "French": "hmong",
    "German": "Hmong-Sprache",
    "Portuguese": "hmong",
    "Italian": "Hmong",
    "Spanish": "Hmong ; Mong",
    "Dutch": "Hmong"
  },
  {
    "alpha2": "hmo",
    "English": "Hiri Motu",
    "French": "hiri motu",
    "German": "Hiri-Motu",
    "Portuguese": "Hiri Motu",
    "Italian": "Hiri Motu",
    "Spanish": "Hiri Motu",
    "Dutch": "Hiri Motu"
  },
  {
    "alpha2": "hrv",
    "English": "Croatian",
    "French": "croate",
    "German": "Kroatisch",
    "Portuguese": "croata",
    "Italian": "Croato",
    "Spanish": "croata",
    "Dutch": "Kroatisch"
  },
  {
    "alpha2": "hsb",
    "English": "Upper Sorbian",
    "French": "haut-sorabe",
    "German": "Obersorbisch",
    "Portuguese": "sorábio alto",
    "Italian": "Lusaziano superiore",
    "Spanish": "Alto sorabo",
    "Dutch": "Oppersorbisch"
  },
  {
    "alpha2": "hun",
    "English": "Hungarian",
    "French": "hongrois",
    "German": "Ungarisch",
    "Portuguese": "húngaro",
    "Italian": "Ungherese",
    "Spanish": "húngaro",
    "Dutch": "Hongaars"
  },
  {
    "alpha2": "hup",
    "English": "Hupa",
    "French": "hupa",
    "German": "Hupa-Sprache",
    "Portuguese": "hupa",
    "Italian": "Hupa",
    "Spanish": "Hupa",
    "Dutch": "Hupa"
  },
  {
    "alpha2": "hye",
    "English": "Armenian",
    "French": "arménien",
    "German": "Armenisch",
    "Portuguese": "armênio",
    "Italian": "Armeno",
    "Spanish": "armenio",
    "Dutch": "Armeens"
  },
  {
    "alpha2": "iba",
    "English": "Iban",
    "French": "iban",
    "German": "Iban-Sprache",
    "Portuguese": "iban",
    "Italian": "Iban",
    "Spanish": "Iban",
    "Dutch": "Iban"
  },
  {
    "alpha2": "ibo",
    "English": "Igbo",
    "French": "igbo",
    "German": "Ibo-Sprache",
    "Portuguese": "ibo",
    "Italian": "Igbo",
    "Spanish": "Igbo",
    "Dutch": "Igbo"
  },
  {
    "alpha2": "isl",
    "English": "Icelandic",
    "French": "islandais",
    "German": "Isländisch",
    "Portuguese": "islandês",
    "Italian": "Islandese",
    "Spanish": "islandés",
    "Dutch": "IJslands"
  },
  {
    "alpha2": "ido",
    "English": "Ido",
    "French": "ido",
    "German": "Ido",
    "Portuguese": "ido",
    "Italian": "Ido",
    "Dutch": "Ido"
  },
  {
    "alpha2": "iii",
    "English": "Sichuan Yi; Nuosu",
    "French": "yi de Sichuan",
    "German": "Lalo-Sprache",
    "Portuguese": "yi de Sichuan",
    "Italian": "Sichuan Yi",
    "Spanish": "Sichuan Yi ; Nuosu",
    "Dutch": "Yi"
  },
  {
    "alpha2": "ijo",
    "English": "Ijo languages",
    "French": "ijo, langues",
    "German": "Ijo-Sprache",
    "Portuguese": "ijo",
    "Italian": "Ijo",
    "Spanish": "Idiomas Ijo",
    "Dutch": "Ijawtalen"
  },
  {
    "alpha2": "iku",
    "English": "Inuktitut",
    "French": "inuktitut",
    "German": "Inuktitut",
    "Portuguese": "inuktitut",
    "Italian": "Inuktitut",
    "Spanish": "Inuktitut",
    "Dutch": "Inuktitut"
  },
  {
    "alpha2": "ile",
    "English": "Interlingue; Occidental",
    "French": "interlingue",
    "German": "Interlingue",
    "Portuguese": "interlíngua",
    "Italian": "Interlingue (Occidental)",
    "Spanish": "Interlingual; Occidental",
    "Dutch": "Interlingue"
  },
  {
    "alpha2": "ilo",
    "English": "Iloko",
    "French": "ilocano",
    "German": "Ilokano-Sprache",
    "Portuguese": "ilocano",
    "Italian": "Ilocano",
    "Spanish": "Iloko",
    "Dutch": "Ilokano"
  },
  {
    "alpha2": "ina",
    "English": "Interlingua (International Auxiliary Language Association)",
    "French": "interlingua (langue auxiliaire internationale)",
    "German": "Interlingua",
    "Portuguese": "interlíngua",
    "Italian": "Interlingua della IALA",
    "Spanish": "Interlingua ( Asociación Internacional de Idiomas Auxiliares )",
    "Dutch": "Interlingua"
  },
  {
    "alpha2": "inc",
    "English": "Indic languages",
    "French": "indo-aryennes, langues",
    "German": "Indoarische Sprachen (Andere)",
    "Portuguese": "indico (Outras)",
    "Italian": "Lingue indoarie (Altre)",
    "Spanish": "Lenguas índicas",
    "Dutch": "Indo-Arische talen"
  },
  {
    "alpha2": "ind",
    "English": "Indonesian",
    "French": "indonésien",
    "German": "Bahasa Indonesia",
    "Portuguese": "indonésio",
    "Italian": "Indonesiano",
    "Spanish": "indonesio",
    "Dutch": "Indonesisch"
  },
  {
    "alpha2": "ine",
    "English": "Indo-European languages",
    "French": "indo-européennes, langues",
    "German": "Indogermanische Sprachen (Andere)",
    "Portuguese": "indo-europeu (Outras)",
    "Italian": "Lingue indoeuropee (Altre)",
    "Spanish": "Lenguas indoeuropeas",
    "Dutch": "Indo-Europese talen"
  },
  {
    "alpha2": "inh",
    "English": "Ingush",
    "French": "ingouche",
    "German": "Inguschisch",
    "Portuguese": "ingush",
    "Italian": "Ingush",
    "Spanish": "Ingush",
    "Dutch": "Ingoesjetisch"
  },
  {
    "alpha2": "ipk",
    "English": "Inupiaq",
    "French": "inupiaq",
    "German": "Inupik",
    "Portuguese": "inupiaq",
    "Italian": "Inupiaq",
    "Spanish": "Inupiaq",
    "Dutch": "Inupiak"
  },
  {
    "alpha2": "ira",
    "English": "Iranian languages",
    "French": "iraniennes, langues",
    "German": "Iranische Sprachen (Andere)",
    "Portuguese": "iraniano (Outras)",
    "Italian": "Lingue iraniche (Altre)",
    "Spanish": "Lenguas iraníes",
    "Dutch": "Iraanse talen"
  },
  {
    "alpha2": "iro",
    "English": "Iroquoian languages",
    "French": "iroquoises, langues",
    "German": "Irokesische Sprachen",
    "Portuguese": "iroquoiano",
    "Italian": "Lingue irochesi",
    "Spanish": "Lenguas iroquesas",
    "Dutch": "Irokese talen"
  },
  {
    "alpha2": "ita",
    "English": "Italian",
    "French": "italien",
    "German": "Italienisch",
    "Portuguese": "italiano",
    "Italian": "Italiano",
    "Spanish": "italiano",
    "Dutch": "Italiaans"
  },
  {
    "alpha2": "jav",
    "English": "Javanese",
    "French": "javanais",
    "German": "Javanisch",
    "Portuguese": "javanês",
    "Italian": "Giavanese",
    "Spanish": "javanés",
    "Dutch": "Javaans"
  },
  {
    "alpha2": "jbo",
    "English": "Lojban",
    "French": "lojban",
    "German": "Lojban",
    "Portuguese": "lojban",
    "Italian": "Lojban",
    "Spanish": "Lojban",
    "Dutch": "Lojban"
  },
  {
    "alpha2": "jpn",
    "English": "Japanese",
    "French": "japonais",
    "German": "Japanisch",
    "Portuguese": "japonês",
    "Italian": "Giapponese",
    "Spanish": "japonés",
    "Dutch": "Japans"
  },
  {
    "alpha2": "jpr",
    "English": "Judeo-Persian",
    "French": "judéo-persan",
    "German": "Jüdisch-Persisch",
    "Portuguese": "judeu-persa",
    "Italian": "Giudeo-persiano,",
    "Spanish": "Judeo-persa",
    "Dutch": "Judeo-Perzisch"
  },
  {
    "alpha2": "jrb",
    "English": "Judeo-Arabic",
    "French": "judéo-arabe",
    "German": "Jüdisch-Arabisch",
    "Portuguese": "judeu-árabe",
    "Italian": "Giudeo-arabico",
    "Spanish": "Judeoárabe",
    "Dutch": "Judeo-Arabisch"
  },
  {
    "alpha2": "kaa",
    "English": "Kara-Kalpak",
    "French": "karakalpak",
    "German": "Karakalpakisch",
    "Portuguese": "kara-kalpak",
    "Italian": "Karakalpako",
    "Spanish": "Kara-Kalpak",
    "Dutch": "Karakalpaks"
  },
  {
    "alpha2": "kab",
    "English": "Kabyle",
    "French": "kabyle",
    "German": "Kabylisch",
    "Portuguese": "cabila",
    "Italian": "Cabilo",
    "Spanish": "Kabyle",
    "Dutch": "Kabylisch"
  },
  {
    "alpha2": "kac",
    "English": "Kachin; Jingpho",
    "French": "kachin; jingpho",
    "German": "Kachin-Sprache",
    "Portuguese": "kachin ou jingpho",
    "Italian": "Kachin",
    "Spanish": "Kachin ; Jingpho",
    "Dutch": "Kachin (Jingpho)"
  },
  {
    "alpha2": "kal",
    "English": "Kalaallisut; Greenlandic",
    "French": "groenlandais",
    "German": "Grönländisch",
    "Portuguese": "groenlandês",
    "Italian": "Groenlandese; Kalaallisut",
    "Spanish": "Kalaallisut ; Groenlandés",
    "Dutch": "Groenlands"
  },
  {
    "alpha2": "kam",
    "English": "Kamba",
    "French": "kamba",
    "German": "Kamba-Sprache",
    "Portuguese": "kamba",
    "Italian": "Kamba",
    "Spanish": "Kamba",
    "Dutch": "Kamba"
  },
  {
    "alpha2": "kan",
    "English": "Kannada",
    "French": "kannada",
    "German": "Kannada",
    "Portuguese": "canarês",
    "Italian": "Kannada",
    "Spanish": "Canarés",
    "Dutch": "Kannada (Kanarees, Kanara)"
  },
  {
    "alpha2": "kar",
    "English": "Karen languages",
    "French": "karen, langues",
    "German": "Karenisch",
    "Portuguese": "karen",
    "Italian": "Karen",
    "Spanish": "Idiomas karen",
    "Dutch": "Karen"
  },
  {
    "alpha2": "kas",
    "English": "Kashmiri",
    "French": "kashmiri",
    "German": "Kaschmiri",
    "Portuguese": "caxemir",
    "Italian": "Kashmiri",
    "Spanish": "Cachemira",
    "Dutch": "Kasjmiri"
  },
  {
    "alpha2": "kat",
    "English": "Georgian",
    "French": "géorgien",
    "German": "Georgisch",
    "Portuguese": "georgiano",
    "Italian": "Georgiano",
    "Spanish": "georgiano",
    "Dutch": "Georgisch"
  },
  {
    "alpha2": "kau",
    "English": "Kanuri",
    "French": "kanouri",
    "German": "Kanuri-Sprache",
    "Portuguese": "kanuri ou canúri",
    "Italian": "Kanuri",
    "Spanish": "Kanuri",
    "Dutch": "Kanuri"
  },
  {
    "alpha2": "kaw",
    "English": "Kawi",
    "French": "kawi",
    "German": "Kawi",
    "Portuguese": "kawi",
    "Italian": "Kawi",
    "Spanish": "Kawi",
    "Dutch": "Kawi"
  },
  {
    "alpha2": "kaz",
    "English": "Kazakh",
    "French": "kazakh",
    "German": "Kasachisch",
    "Portuguese": "cazaque",
    "Italian": "Kazako",
    "Spanish": "Kazajo",
    "Dutch": "Kazachs"
  },
  {
    "alpha2": "kbd",
    "English": "Kabardian",
    "French": "kabardien",
    "German": "Kabardinisch",
    "Portuguese": "cabardiano",
    "Italian": "Kabardo",
    "Spanish": "Kabardiano",
    "Dutch": "Kabardijns"
  },
  {
    "alpha2": "kha",
    "English": "Khasi",
    "French": "khasi",
    "German": "Khasi-Sprache",
    "Portuguese": "khasi",
    "Italian": "Khasi",
    "Spanish": "Khasi",
    "Dutch": "Khasi"
  },
  {
    "alpha2": "khi",
    "English": "Khoisan languages",
    "French": "khoïsan, langues",
    "German": "Khoisan-Sprachen (Andere)",
    "Portuguese": "khoisano (Outras)",
    "Italian": "Khoisan (Altre)",
    "Spanish": "Lenguas khoisan",
    "Dutch": "Khoisantalen"
  },
  {
    "alpha2": "khm",
    "English": "Central Khmer",
    "French": "khmer central",
    "German": "Kambodschanisch",
    "Portuguese": "khmer",
    "Italian": "Khmer",
    "Spanish": "Khmer central",
    "Dutch": "Khmer, Cambodjaans"
  },
  {
    "alpha2": "kho",
    "English": "Khotanese; Sakan",
    "French": "khotanais; sakan",
    "German": "Sakisch",
    "Portuguese": "khotanês",
    "Italian": "Khotanese",
    "Spanish": "Khotanese ; Sakan",
    "Dutch": "Hotanees"
  },
  {
    "alpha2": "kik",
    "English": "Kikuyu; Gikuyu",
    "French": "kikuyu",
    "German": "Kikuyu-Sprache",
    "Portuguese": "kikuyu; Gikuyu",
    "Italian": "Kikuyu; Gikuyu",
    "Spanish": "Kikuyu ; Gikuyu",
    "Dutch": "Gikuyu"
  },
  {
    "alpha2": "kin",
    "English": "Kinyarwanda",
    "French": "rwanda",
    "German": "Rwanda-Sprache",
    "Portuguese": "quiniaruanda",
    "Italian": "Kinyarwanda",
    "Spanish": "Kinyarwanda",
    "Dutch": "Kinyarwanda"
  },
  {
    "alpha2": "kir",
    "English": "Kirghiz; Kyrgyz",
    "French": "kirghiz",
    "German": "Kirgisisch",
    "Portuguese": "quirguiz",
    "Italian": "Kirghiso",
    "Spanish": "Kirghiz ; Kirguís",
    "Dutch": "Kirgizisch"
  },
  {
    "alpha2": "kmb",
    "English": "Kimbundu",
    "French": "kimbundu",
    "German": "Kimbundu-Sprache",
    "Portuguese": "quimbundu",
    "Italian": "Kimbundu",
    "Spanish": "Kimbundu",
    "Dutch": "Kimbundu"
  },
  {
    "alpha2": "kok",
    "English": "Konkani",
    "French": "konkani",
    "German": "Konkani",
    "Portuguese": "concani",
    "Italian": "Konkani",
    "Spanish": "Konkani",
    "Dutch": "Konkani"
  },
  {
    "alpha2": "kom",
    "English": "Komi",
    "French": "kom",
    "German": "Komi-Sprache",
    "Portuguese": "komi",
    "Italian": "Komi",
    "Spanish": "Komi",
    "Dutch": "Zurjeens (Komi)"
  },
  {
    "alpha2": "kon",
    "English": "Kongo",
    "French": "kongo",
    "German": "Kongo-Sprache",
    "Portuguese": "kongo",
    "Italian": "Kongo",
    "Spanish": "Kongo",
    "Dutch": "Kongo"
  },
  {
    "alpha2": "kor",
    "English": "Korean",
    "French": "coréen",
    "German": "Koreanisch",
    "Portuguese": "coreano",
    "Italian": "Coreano",
    "Spanish": "coreano",
    "Dutch": "Koreaans"
  },
  {
    "alpha2": "kos",
    "English": "Kosraean",
    "French": "kosrae",
    "German": "Kosraeanisch",
    "Portuguese": "kosraeano",
    "Italian": "Kosraean",
    "Spanish": "Kosraean",
    "Dutch": "Kosraeaans"
  },
  {
    "alpha2": "kpe",
    "English": "Kpelle",
    "French": "kpellé",
    "German": "Kpelle-Sprache",
    "Portuguese": "kpelle",
    "Italian": "Kpelle",
    "Spanish": "Kpelle",
    "Dutch": "Kpelle"
  },
  {
    "alpha2": "krc",
    "English": "Karachay-Balkar",
    "French": "karatchai balkar",
    "German": "Karatschaiisch-Balkarisch",
    "Portuguese": "carachaio-bálcara",
    "Italian": "Caraciai-Balcaro",
    "Spanish": "Karachay-Balkar",
    "Dutch": "Karatsjaj-Balkaars"
  },
  {
    "alpha2": "krl",
    "English": "Karelian",
    "French": "carélien",
    "German": "Karelisch",
    "Portuguese": "carélio",
    "Spanish": "Carelio",
    "Dutch": "Karelisch"
  },
  {
    "alpha2": "kro",
    "English": "Kru languages",
    "French": "krou, langues",
    "German": "Kru-Sprachen (Andere)",
    "Portuguese": "kru",
    "Italian": "Kru",
    "Spanish": "Idiomas kru",
    "Dutch": "Krutalen"
  },
  {
    "alpha2": "kru",
    "English": "Kurukh",
    "French": "kurukh",
    "German": "Oraon-Sprache",
    "Portuguese": "kurux",
    "Italian": "Kurukh",
    "Spanish": "Kurukh",
    "Dutch": "Kurukh"
  },
  {
    "alpha2": "kua",
    "English": "Kuanyama; Kwanyama",
    "French": "kuanyama; kwanyama",
    "German": "Kwanyama-Sprache",
    "Portuguese": "oshikwanyama",
    "Italian": "Kuanyama; Kwanyama",
    "Spanish": "Kuanyama ; Kwanyama",
    "Dutch": "Kwanyama"
  },
  {
    "alpha2": "kum",
    "English": "Kumyk",
    "French": "koumyk",
    "German": "Kumükisch",
    "Portuguese": "kumyk",
    "Italian": "Cumucco",
    "Spanish": "Kumyk",
    "Dutch": "Kumyk"
  },
  {
    "alpha2": "kur",
    "English": "Kurdish",
    "French": "kurde",
    "German": "Kurdisch",
    "Portuguese": "curdo",
    "Italian": "Curdo",
    "Spanish": "kurdo",
    "Dutch": "Koerdisch"
  },
  {
    "alpha2": "kut",
    "English": "Kutenai",
    "French": "kutenai",
    "German": "Kutenai-Sprache",
    "Portuguese": "kutenai",
    "Italian": "Kutenai",
    "Spanish": "Kutenai",
    "Dutch": "Kutenai"
  },
  {
    "alpha2": "lad",
    "English": "Ladino",
    "French": "judéo-espagnol",
    "German": "Judenspanisch",
    "Portuguese": "ladino; judeu-espanhol",
    "Italian": "Ladino",
    "Spanish": "Ladino",
    "Dutch": "Ladino"
  },
  {
    "alpha2": "lah",
    "English": "Lahnda",
    "French": "lahnda",
    "German": "Lahnda",
    "Portuguese": "lahnda",
    "Italian": "Lahnda",
    "Spanish": "Lahnda",
    "Dutch": "Lahnda"
  },
  {
    "alpha2": "lam",
    "English": "Lamba",
    "French": "lamba",
    "German": "Lamba-Sprache (Bantusprache)",
    "Portuguese": "lamba",
    "Italian": "Lamba",
    "Spanish": "Lamba",
    "Dutch": "Lamba"
  },
  {
    "alpha2": "lao",
    "English": "Lao",
    "French": "lao",
    "German": "Laotisch",
    "Portuguese": "laociano",
    "Italian": "Lao",
    "Spanish": "Lao",
    "Dutch": "Laotiaans"
  },
  {
    "alpha2": "lat",
    "English": "Latin",
    "French": "latin",
    "German": "Latein",
    "Portuguese": "latim",
    "Italian": "Latino",
    "Spanish": "latín",
    "Dutch": "Latijn"
  },
  {
    "alpha2": "lep",
    "English": "Lepcha",
    "French": "lepcha",
    "German": "Lepcha",
    "Portuguese": "lepcha",
    "Italian": "Lepcha",
    "Spanish": "lepcha",
    "Dutch": "Lepcha"
  },
  {
    "alpha2": "lav",
    "English": "Latvian",
    "French": "letton",
    "German": "Lettisch",
    "Portuguese": "letão",
    "Italian": "Lettone",
    "Spanish": "letón",
    "Dutch": "Lets"
  },
  {
    "alpha2": "lez",
    "English": "Lezghian",
    "French": "lezghien",
    "German": "Lesgisch",
    "Portuguese": "lezgui‌",
    "Italian": "Lesgo",
    "Spanish": "Lezghian",
    "Dutch": "Lezgisch"
  },
  {
    "alpha2": "lim",
    "English": "Limburgan; Limburger; Limburgish",
    "French": "limbourgeois",
    "German": "Limburgisch",
    "Portuguese": "limburguês",
    "Italian": "Limburghese",
    "Spanish": "Limburgan ; Limburger ; Limburgués",
    "Dutch": "Limburgs"
  },
  {
    "alpha2": "lin",
    "English": "Lingala",
    "French": "lingala",
    "German": "Lingala",
    "Portuguese": "lingala",
    "Italian": "Lingala",
    "Spanish": "Lingala",
    "Dutch": "Lingala"
  },
  {
    "alpha2": "lit",
    "English": "Lithuanian",
    "French": "lituanien",
    "German": "Litauisch",
    "Portuguese": "lituano",
    "Italian": "Lituano",
    "Spanish": "lituano",
    "Dutch": "Litouws"
  },
  {
    "alpha2": "lol",
    "English": "Mongo",
    "French": "mongo",
    "German": "Mongo-Sprache",
    "Portuguese": "mongo",
    "Italian": "Mongo",
    "Spanish": "Mongo",
    "Dutch": "Mongo"
  },
  {
    "alpha2": "loz",
    "English": "Lozi",
    "French": "lozi",
    "German": "Lozi",
    "Portuguese": "lozi",
    "Italian": "Lozi",
    "Spanish": "Lozi",
    "Dutch": "Lozi"
  },
  {
    "alpha2": "ltz",
    "English": "Luxembourgish; Letzeburgesch",
    "French": "luxembourgeois",
    "German": "Luxemburgisch",
    "Portuguese": "luxemburguês",
    "Italian": "Lussemburghese",
    "Spanish": "Luxemburgués ; Letzeburgesch",
    "Dutch": "Luxemburgs"
  },
  {
    "alpha2": "lua",
    "English": "Luba-Lulua",
    "French": "luba-lulua",
    "German": "Lulua-Sprache",
    "Portuguese": "luba-lulua",
    "Italian": "Luba-lulua",
    "Spanish": "Luba-Lulua",
    "Dutch": "Luba-Lulua"
  },
  {
    "alpha2": "lub",
    "English": "Luba-Katanga",
    "French": "luba-katanga",
    "German": "Luba-Katanga-Sprache",
    "Portuguese": "luba-katanga",
    "Italian": "Luba-katanga",
    "Spanish": "Luba-Katanga",
    "Dutch": "Luba-Katanga"
  },
  {
    "alpha2": "lug",
    "English": "Ganda",
    "French": "ganda",
    "German": "Ganda-Sprache",
    "Portuguese": "luganda",
    "Italian": "Ganda",
    "Spanish": "Ganda",
    "Dutch": "Luganda"
  },
  {
    "alpha2": "lui",
    "English": "Luiseno",
    "French": "luiseno",
    "German": "Luiseño-Sprache",
    "Portuguese": "luiseña",
    "Italian": "Luiseno",
    "Spanish": "Luiseno",
    "Dutch": "Luiseno"
  },
  {
    "alpha2": "lun",
    "English": "Lunda",
    "French": "lunda",
    "German": "Lunda-Sprache",
    "Portuguese": "lunda",
    "Italian": "Lunda",
    "Spanish": "Lunda",
    "Dutch": "Lunda"
  },
  {
    "alpha2": "luo",
    "English": "Luo (Kenya and Tanzania)",
    "French": "luo (Kenya et Tanzanie)",
    "German": "Luo-Sprache",
    "Portuguese": "luo",
    "Italian": "Luo (Kenya e Tanzania)",
    "Spanish": "Luo (Kenia y Tanzania)",
    "Dutch": "Luo (Kenia en Tanzania)"
  },
  {
    "alpha2": "lus",
    "English": "Lushai",
    "French": "lushai",
    "German": "Lushai-Sprache",
    "Portuguese": "lushai",
    "Italian": "Lushai",
    "Spanish": "Lushai",
    "Dutch": "Lushai"
  },
  {
    "alpha2": "mad",
    "English": "Madurese",
    "French": "madourais",
    "German": "Maduresisch",
    "Portuguese": "maduresa",
    "Italian": "Madurese",
    "Spanish": "Madurese",
    "Dutch": "Madoerees"
  },
  {
    "alpha2": "mag",
    "English": "Magahi",
    "French": "magahi",
    "German": "Magadhi",
    "Portuguese": "magahi",
    "Italian": "Magahi",
    "Spanish": "Magahi",
    "Dutch": "Magahi"
  },
  {
    "alpha2": "mah",
    "English": "Marshallese",
    "French": "marshall",
    "German": "Marschallesisch",
    "Portuguese": "marshallês",
    "Italian": "Marshallese",
    "Spanish": "Marshalés",
    "Dutch": "Marshallees"
  },
  {
    "alpha2": "mai",
    "English": "Maithili",
    "French": "maithili",
    "German": "Maithili",
    "Portuguese": "maithili",
    "Italian": "Maithili",
    "Spanish": "Maithili",
    "Dutch": "Maithili"
  },
  {
    "alpha2": "mak",
    "English": "Makasar",
    "French": "makassar",
    "German": "Makassarisch",
    "Portuguese": "makasar",
    "Italian": "Makasar",
    "Spanish": "Makasar",
    "Dutch": "Makassaars"
  },
  {
    "alpha2": "mal",
    "English": "Malayalam",
    "French": "malayalam",
    "German": "Malayalam",
    "Portuguese": "malaiala",
    "Italian": "Malayalam",
    "Spanish": "Malayalam",
    "Dutch": "Malayalam"
  },
  {
    "alpha2": "man",
    "English": "Mandingo",
    "French": "mandingue",
    "German": "Manding",
    "Portuguese": "mandinga",
    "Italian": "Mandingo",
    "Spanish": "Mandingo",
    "Dutch": "Mandinka"
  },
  {
    "alpha2": "map",
    "English": "Austronesian languages",
    "French": "austronésiennes, langues",
    "German": "Austronesische Sprachen (Andere)",
    "Portuguese": "austronesio (Outras)",
    "Italian": "Austronesiano (Altre)",
    "Spanish": "Lenguas austronesias",
    "Dutch": "Austronesische talen"
  },
  {
    "alpha2": "mar",
    "English": "Marathi",
    "French": "marathe",
    "German": "Marathi",
    "Portuguese": "marata",
    "Italian": "Marathi",
    "Spanish": "Marathi",
    "Dutch": "Marathi"
  },
  {
    "alpha2": "mas",
    "English": "Masai",
    "French": "massaï",
    "German": "Massai-Sprache",
    "Portuguese": "masai",
    "Italian": "Masai",
    "Spanish": "Masai",
    "Dutch": "Masai"
  },
  {
    "alpha2": "mdf",
    "English": "Moksha",
    "French": "moksa",
    "German": "Mokscha-Sprache",
    "Portuguese": "moksha",
    "Italian": "Mokša",
    "Spanish": "Moksha",
    "Dutch": "Moksha"
  },
  {
    "alpha2": "mdr",
    "English": "Mandar",
    "French": "mandar",
    "German": "Mandaresisch",
    "Portuguese": "mandar",
    "Italian": "Mandar",
    "Spanish": "Mandarín",
    "Dutch": "Mandar"
  },
  {
    "alpha2": "men",
    "English": "Mende",
    "French": "mendé",
    "German": "Mende-Sprache",
    "Portuguese": "mende",
    "Italian": "Mende",
    "Spanish": "Mende",
    "Dutch": "Mende"
  },
  {
    "alpha2": "mga",
    "English": "Irish, Middle (900-1200)",
    "French": "irlandais moyen (900-1200)",
    "German": "Mittelirisch",
    "Portuguese": "irlandês médio (900-1200)",
    "Italian": "Irlandese, Medio (900-1200)",
    "Spanish": "Irlandés, Medio (900-1200)",
    "Dutch": "Middel-iers (900-1200)"
  },
  {
    "alpha2": "mic",
    "English": "Mi'kmaq; Micmac",
    "French": "mi'kmaq; micmac",
    "German": "Micmac-Sprache",
    "Portuguese": "micmac; Mi'kmaq",
    "Italian": "Mi'kmaq; Micmac",
    "Spanish": "Mi'kmaq ; Micmac",
    "Dutch": "Micmac"
  },
  {
    "alpha2": "min",
    "English": "Minangkabau",
    "French": "minangkabau",
    "German": "Minangkabau-Sprache",
    "Portuguese": "minangkabau",
    "Italian": "Minangkabau",
    "Spanish": "Minangkabau",
    "Dutch": "Minangkabau"
  },
  {
    "alpha2": "mis",
    "English": "Uncoded languages",
    "French": "langues non codées",
    "German": "Einzelne andere Sprachen",
    "Portuguese": "línguas miscelâneas",
    "Italian": "Lingue varie",
    "Spanish": "Idiomas no codificados",
    "Dutch": "niet gecodeerde talen"
  },
  {
    "alpha2": "mkd",
    "English": "Macedonian",
    "French": "macédonien",
    "German": "Makedonisch",
    "Portuguese": "macedônio",
    "Italian": "Macedone",
    "Spanish": "macedónio",
    "Dutch": "Macedonisch"
  },
  {
    "alpha2": "mkh",
    "English": "Mon-Khmer languages",
    "French": "môn-khmer, langues",
    "German": "Mon-Khmer-Sprachen (Andere)",
    "Portuguese": "mon-khmer (Outras)",
    "Italian": "Mon-khmer (Altre)",
    "Spanish": "Idiomas Mon-Khmer",
    "Dutch": "Mon-Khmertalen"
  },
  {
    "alpha2": "mlg",
    "English": "Malagasy",
    "French": "malgache",
    "German": "Malagassi-Sprache",
    "Portuguese": "malgaxe",
    "Italian": "Malgascio",
    "Spanish": "Madagascarí",
    "Dutch": "Plateaumalagasi"
  },
  {
    "alpha2": "mlt",
    "English": "Maltese",
    "French": "maltais",
    "German": "Maltesisch",
    "Portuguese": "maltês",
    "Italian": "Maltese",
    "Spanish": "Maltés",
    "Dutch": "Maltees"
  },
  {
    "alpha2": "mnc",
    "English": "Manchu",
    "French": "mandchou",
    "German": "Mandschurisch",
    "Portuguese": "manchu",
    "Italian": "Mancese",
    "Spanish": "Manchú",
    "Dutch": "Mantsjoe"
  },
  {
    "alpha2": "mni",
    "English": "Manipuri",
    "French": "manipuri",
    "German": "Meitei-Sprache",
    "Portuguese": "manipuri",
    "Italian": "Manipuri",
    "Spanish": "Manipuri",
    "Dutch": "Meitei (Manipuri)"
  },
  {
    "alpha2": "mno",
    "English": "Manobo languages",
    "French": "manobo, langues",
    "German": "Manobo-Sprachen",
    "Portuguese": "manobo",
    "Italian": "Lingue manobo",
    "Spanish": "Idiomas manobo",
    "Dutch": "Manobotalen"
  },
  {
    "alpha2": "moh",
    "English": "Mohawk",
    "French": "mohawk",
    "German": "Mohawk-Sprache",
    "Portuguese": "mohawk",
    "Italian": "Mohawk",
    "Spanish": "Mohawk",
    "Dutch": "Mohawk"
  },
  {
    "alpha2": "mon",
    "English": "Mongolian",
    "French": "mongol",
    "German": "Mongolisch",
    "Portuguese": "mongol",
    "Italian": "Mongolo",
    "Spanish": "mongol",
    "Dutch": "Mongools"
  },
  {
    "alpha2": "mos",
    "English": "Mossi",
    "French": "moré",
    "German": "Mossi-Sprache",
    "Portuguese": "mossi",
    "Italian": "Mossi",
    "Spanish": "Mossi",
    "Dutch": "Mossi"
  },
  {
    "alpha2": "mri",
    "English": "Maori",
    "French": "maori",
    "German": "Maori-Sprache",
    "Portuguese": "Māori",
    "Italian": "Māori",
    "Spanish": "Maorí",
    "Dutch": "Maori"
  },
  {
    "alpha2": "msa",
    "English": "Malay",
    "French": "malais",
    "German": "Malaiisch",
    "Portuguese": "malaio",
    "Italian": "Malay",
    "Spanish": "malayo",
    "Dutch": "Maleis"
  },
  {
    "alpha2": "mul",
    "English": "Multiple languages",
    "French": "multilingue",
    "German": "Mehrere Sprachen",
    "Portuguese": "línguas múltiplas (várias usadas)",
    "Italian": "Lingue multiple (vengono usate diverse lingue)",
    "Spanish": "Múltiples idiomas",
    "Dutch": "meerdere talen"
  },
  {
    "alpha2": "mun",
    "English": "Munda languages",
    "French": "mounda, langues",
    "German": "Mundasprachen (Andere)",
    "Portuguese": "línguas munda",
    "Italian": "Lingue munda",
    "Spanish": "Idiomas munda",
    "Dutch": "Mundatalen"
  },
  {
    "alpha2": "mus",
    "English": "Creek",
    "French": "muskogee",
    "German": "Muskogisch",
    "Portuguese": "creek",
    "Italian": "Creek",
    "Spanish": "Cala",
    "Dutch": "Muskogitalen"
  },
  {
    "alpha2": "mwl",
    "English": "Mirandese",
    "French": "mirandais",
    "German": "Mirandesisch",
    "Portuguese": "mirandês",
    "Italian": "Mirandese",
    "Spanish": "Mirandese",
    "Dutch": "Mirandees"
  },
  {
    "alpha2": "mwr",
    "English": "Marwari",
    "French": "marvari",
    "German": "Marwari",
    "Portuguese": "marwari",
    "Italian": "Marwari",
    "Spanish": "Marwari",
    "Dutch": "Marwari"
  },
  {
    "alpha2": "mya",
    "English": "Burmese",
    "French": "birman",
    "German": "Birmanisch",
    "Portuguese": "birmanês; burmês",
    "Italian": "Birmano",
    "Spanish": "birmano",
    "Dutch": "Birmaans, Birmees"
  },
  {
    "alpha2": "myn",
    "English": "Mayan languages",
    "French": "maya, langues",
    "German": "Maya-Sprachen",
    "Portuguese": "maia",
    "Italian": "Maya",
    "Spanish": "Lenguas mayas",
    "Dutch": "Mayatalen"
  },
  {
    "alpha2": "myv",
    "English": "Erzya",
    "French": "erza",
    "German": "Erza-Mordwinisch",
    "Portuguese": "erzya",
    "Italian": "Erza",
    "Spanish": "Erzya",
    "Dutch": "Erzja"
  },
  {
    "alpha2": "nah",
    "English": "Nahuatl languages",
    "French": "nahuatl, langues",
    "German": "Nahuatl",
    "Portuguese": "nahuatl; náuatle",
    "Italian": "Nahuatl",
    "Spanish": "Lenguas náhuatl",
    "Dutch": "Nahuatl"
  },
  {
    "alpha2": "nai",
    "English": "North American Indian languages",
    "French": "nord-amérindiennes, langues",
    "German": "Indianersprachen, Nordamerika (Andere)",
    "Portuguese": "ameríndio (Outras)",
    "Italian": "Indiano nordamericano (Altre)",
    "Spanish": "Idiomas de los indios norteamericanos",
    "Dutch": "Noord-Amerikaans Indiaanse talen"
  },
  {
    "alpha2": "nap",
    "English": "Neapolitan",
    "French": "napolitain",
    "German": "Neapel / Mundart",
    "Portuguese": "napolitano",
    "Italian": "Napoletano",
    "Spanish": "napolitano",
    "Dutch": "Napolitaans"
  },
  {
    "alpha2": "nau",
    "English": "Nauru",
    "French": "nauruan",
    "German": "Nauruanisch",
    "Portuguese": "nauruano",
    "Italian": "Nauru",
    "Spanish": "Nauru",
    "Dutch": "Nauruaans"
  },
  {
    "alpha2": "nav",
    "English": "Navajo; Navaho",
    "French": "navaho",
    "German": "Navajo-Sprache",
    "Portuguese": "navajo; navaho",
    "Italian": "Navajo; Navaho",
    "Spanish": "Navajo ; Navajo",
    "Dutch": "Navajo"
  },
  {
    "alpha2": "nbl",
    "English": "Ndebele, South; South Ndebele",
    "French": "ndébélé du Sud",
    "German": "Ndebele-Sprache (Transvaal)",
    "Portuguese": "ndebele do sul",
    "Italian": "Ndebele meridionale",
    "Spanish": "Ndebele, Sur; Ndebele del sur",
    "Dutch": "Zuid-Ndebele"
  },
  {
    "alpha2": "nde",
    "English": "Ndebele, North; North Ndebele",
    "French": "ndébélé du Nord",
    "German": "Ndebele-Sprache (Simbabwe)",
    "Portuguese": "ndebele do norte",
    "Italian": "Ndebele settentrionale",
    "Spanish": "Ndebele, Norte; North Ndebele",
    "Dutch": "Noord-Ndebele"
  },
  {
    "alpha2": "ndo",
    "English": "Ndonga",
    "French": "ndonga",
    "German": "Ndonga",
    "Portuguese": "ndonga",
    "Italian": "Ndonga",
    "Spanish": "Ndonga",
    "Dutch": "Ndonga"
  },
  {
    "alpha2": "nds",
    "English": "Low German; Low Saxon; German, Low; Saxon, Low",
    "French": "bas allemand; bas saxon; allemand, bas; saxon, bas",
    "German": "Niederdeutsch",
    "Portuguese": "baixo saxão",
    "Italian": "Basso-tedesco",
    "Spanish": "Bajo alemán ; Bajo sajón; Alemán, bajo; Sajón, bajo",
    "Dutch": "Nederduits"
  },
  {
    "alpha2": "nep",
    "English": "Nepali",
    "French": "népalais",
    "German": "Nepali",
    "Portuguese": "nepali, nepalês",
    "Italian": "Nepalese",
    "Spanish": "Nepalí",
    "Dutch": "Nepalees"
  },
  {
    "alpha2": "new",
    "English": "Nepal Bhasa; Newari",
    "French": "nepal bhasa; newari",
    "German": "Newari",
    "Portuguese": "newari",
    "Italian": "Newari; Nepal Bhasa",
    "Spanish": "Nepal Bhasa ; Newari",
    "Dutch": "Nepalbhasa (Newari)"
  },
  {
    "alpha2": "nia",
    "English": "Nias",
    "French": "nias",
    "German": "Nias-Sprache",
    "Portuguese": "nias",
    "Italian": "Nias",
    "Spanish": "Nias",
    "Dutch": "Nias"
  },
  {
    "alpha2": "nic",
    "English": "Niger-Kordofanian languages",
    "French": "nigéro-kordofaniennes, langues",
    "German": "Nigerkordofanische Sprachen (Andere)",
    "Portuguese": "niger-cordofanio (Outras)",
    "Italian": "Niger-kordofaniane (Altre)",
    "Spanish": "Idiomas niger-kordofanianos",
    "Dutch": "Niger-Congotalen (overige)"
  },
  {
    "alpha2": "niu",
    "English": "Niuean",
    "French": "niué",
    "German": "Niue-Sprache",
    "Portuguese": "niueano",
    "Italian": "Niueano",
    "Spanish": "Niuean",
    "Dutch": "Niueaans"
  },
  {
    "alpha2": "nld",
    "English": "Dutch; Flemish",
    "French": "néerlandais; flamand",
    "German": "Niederländisch",
    "Portuguese": "holandês",
    "Italian": "Olandese; Fiammingo",
    "Spanish": "holandesa ; flamenco",
    "Dutch": "Nederlands"
  },
  {
    "alpha2": "nno",
    "English": "Norwegian Nynorsk; Nynorsk, Norwegian",
    "French": "norvégien nynorsk; nynorsk, norvégien",
    "German": "Nynorsk",
    "Portuguese": "novo norueguês",
    "Italian": "Norvegese Nynorsk",
    "Spanish": "Noruego Nynorsk ; Nynorsk, noruego",
    "Dutch": "Nynorsk (Nieuw-Noors)"
  },
  {
    "alpha2": "nob",
    "English": "Bokmål, Norwegian; Norwegian Bokmål",
    "French": "norvégien bokmål",
    "German": "Bokmål",
    "Portuguese": "bokmål norueguês",
    "Italian": "Norvegese Bokmål",
    "Spanish": "Bokmål , noruego; Noruego bokmål",
    "Dutch": "Bokmål-Noors"
  },
  {
    "alpha2": "nog",
    "English": "Nogai",
    "French": "nogaï; nogay",
    "German": "Nogaisch",
    "Portuguese": "nogai",
    "Italian": "Nogai",
    "Spanish": "Nogai",
    "Dutch": "Nogai"
  },
  {
    "alpha2": "non",
    "English": "Norse, Old",
    "French": "norrois, vieux",
    "German": "Altnorwegisch",
    "Portuguese": "norueguês antigo; nórdico arcaico",
    "Italian": "norreno",
    "Spanish": "Nórdico, viejo",
    "Dutch": "Oudnoords"
  },
  {
    "alpha2": "nor",
    "English": "Norwegian",
    "French": "norvégien",
    "German": "Norwegisch",
    "Portuguese": "norueguês",
    "Italian": "Norvegese",
    "Spanish": "noruego",
    "Dutch": "Noors"
  },
  {
    "alpha2": "nqo",
    "English": "N'Ko",
    "French": "n'ko",
    "German": "N'Ko",
    "Spanish": "N'Ko",
    "Dutch": "N'ko"
  },
  {
    "alpha2": "nso",
    "English": "Pedi; Sepedi; Northern Sotho",
    "French": "pedi; sepedi; sotho du Nord",
    "German": "Pedi-Sprache",
    "Portuguese": "seSotho do norte",
    "Italian": "Lingua sesotho del nord; Pedi; Sepedi",
    "Spanish": "Pedi ; Sepedi ; Sotho septentrional",
    "Dutch": "Pedi (Sepedi, Noord-Sothotisch)"
  },
  {
    "alpha2": "nub",
    "English": "Nubian languages",
    "French": "nubiennes, langues",
    "German": "Nubische Sprachen",
    "Portuguese": "nubio",
    "Italian": "Lingue nubiane",
    "Spanish": "Lenguas nubias",
    "Dutch": "Nubische talen"
  },
  {
    "alpha2": "nwc",
    "English": "Classical Newari; Old Newari; Classical Nepal Bhasa",
    "French": "newari classique",
    "German": "Alt-Newari",
    "Portuguese": "newari clássico",
    "Italian": "Classical Newari; Old Newari; Classical Nepal Bhasa",
    "Spanish": "Newari clásico ; Old Newari ; Nepal clásico Bhasa",
    "Dutch": "Klassiek Newari (Klassiek Nepalbhasa)"
  },
  {
    "alpha2": "nya",
    "English": "Chichewa; Chewa; Nyanja",
    "French": "chichewa; chewa; nyanja",
    "German": "Nyanja-Sprache",
    "Portuguese": "nianja; chewa; nyanja",
    "Italian": "Chichewa; Chewa; Nyanja",
    "Spanish": "Chichewa ; Chewa ; Nyanja",
    "Dutch": "Nyanja"
  },
  {
    "alpha2": "nym",
    "English": "Nyamwezi",
    "French": "nyamwezi",
    "German": "Nyamwezi-Sprache",
    "Portuguese": "nyamwezi",
    "Italian": "Nyamwezi",
    "Spanish": "Nyamwezi",
    "Dutch": "Nyamwezi"
  },
  {
    "alpha2": "nyn",
    "English": "Nyankole",
    "French": "nyankolé",
    "German": "Nkole-Sprache",
    "Portuguese": "nyankole",
    "Italian": "Nyankole",
    "Spanish": "Nyankole",
    "Dutch": "Nyankole"
  },
  {
    "alpha2": "nyo",
    "English": "Nyoro",
    "French": "nyoro",
    "German": "Nyoro-Sprache",
    "Portuguese": "nyoro",
    "Italian": "Nyoro",
    "Spanish": "Nyoro",
    "Dutch": "Nyoro"
  },
  {
    "alpha2": "nzi",
    "English": "Nzima",
    "French": "nzema",
    "German": "Nzima-Sprache",
    "Portuguese": "nzima",
    "Italian": "Nzima",
    "Spanish": "Nzima",
    "Dutch": "Nzima"
  },
  {
    "alpha2": "oci",
    "English": "Occitan (post 1500)",
    "French": "occitan (après 1500)",
    "German": "Okzitanisch",
    "Portuguese": "occitano (depois 1500); provençal",
    "Italian": "Occitano (dopo il 1500); Provenzale",
    "Spanish": "Occitano (después de 1500)",
    "Dutch": "Occitaans"
  },
  {
    "alpha2": "oji",
    "English": "Ojibwa",
    "French": "ojibwa",
    "German": "Ojibwa-Sprache",
    "Portuguese": "chippewa",
    "Italian": "Ojibwa",
    "Spanish": "Ojibwa",
    "Dutch": "Ojibweg"
  },
  {
    "alpha2": "ori",
    "English": "Oriya",
    "French": "oriya",
    "German": "Oriya-Sprache",
    "Portuguese": "oriá",
    "Italian": "Oriya",
    "Spanish": "Oriya",
    "Dutch": "Odia (Oriya)"
  },
  {
    "alpha2": "orm",
    "English": "Oromo",
    "French": "galla",
    "German": "Galla-Sprache",
    "Portuguese": "oromo",
    "Italian": "Oromo",
    "Spanish": "Oromo",
    "Dutch": "Afaan Oromo"
  },
  {
    "alpha2": "osa",
    "English": "Osage",
    "French": "osage",
    "German": "Osage-Sprache",
    "Portuguese": "osage",
    "Italian": "Osage",
    "Spanish": "Osage",
    "Dutch": "Osage"
  },
  {
    "alpha2": "oss",
    "English": "Ossetian; Ossetic",
    "French": "ossète",
    "German": "Ossetisch",
    "Portuguese": "oseto",
    "Italian": "Osseto",
    "Spanish": "Osetio ; Osético",
    "Dutch": "Ossetisch"
  },
  {
    "alpha2": "ota",
    "English": "Turkish, Ottoman (1500-1928)",
    "French": "turc ottoman (1500-1928)",
    "German": "Osmanisch",
    "Portuguese": "turco otomano (1500-1928)",
    "Italian": "Turco, ottomano (1500-1928)",
    "Spanish": "Turco, otomano (1500-1928)",
    "Dutch": "Osmaans (Ottomaans) (1500-1928)"
  },
  {
    "alpha2": "oto",
    "English": "Otomian languages",
    "French": "otomi, langues",
    "German": "Otomangue-Sprachen",
    "Portuguese": "otomiano",
    "Italian": "Lingue otomiane",
    "Spanish": "Lenguas otomianas",
    "Dutch": "Otomi"
  },
  {
    "alpha2": "paa",
    "English": "Papuan languages",
    "French": "papoues, langues",
    "German": "Papuasprachen (Andere)",
    "Portuguese": "papuano (Outras)",
    "Italian": "Papuasiche",
    "Spanish": "Lenguas papúes",
    "Dutch": "Papoeatalen (overige)"
  },
  {
    "alpha2": "pag",
    "English": "Pangasinan",
    "French": "pangasinan",
    "German": "Pangasinan-Sprache",
    "Portuguese": "pangasinan",
    "Italian": "Pangasinan",
    "Spanish": "Pangasinan",
    "Dutch": "Pangasinan"
  },
  {
    "alpha2": "pal",
    "English": "Pahlavi",
    "French": "pahlavi",
    "German": "Mittelpersisch, Pahlavi",
    "Portuguese": "pálavi",
    "Italian": "Pahlavi",
    "Spanish": "Pahlavi",
    "Dutch": "Pahlavi"
  },
  {
    "alpha2": "pam",
    "English": "Pampanga; Kapampangan",
    "French": "pampangan",
    "German": "Pampanggan-Sprache",
    "Portuguese": "pampanga",
    "Italian": "Pampanga; Kapampangan",
    "Spanish": "Pampanga ; Kapampangan",
    "Dutch": "Pampanga"
  },
  {
    "alpha2": "pan",
    "English": "Panjabi; Punjabi",
    "French": "pendjabi",
    "German": "Pandschabi-Sprache",
    "Portuguese": "panjabi",
    "Italian": "Punjabi",
    "Spanish": "Panjabi ; punjabi",
    "Dutch": "Punjabi"
  },
  {
    "alpha2": "pap",
    "English": "Papiamento",
    "French": "papiamento",
    "German": "Papiamento",
    "Portuguese": "papiamento",
    "Italian": "Papiamento",
    "Spanish": "Papiamento",
    "Dutch": "Papiaments"
  },
  {
    "alpha2": "pau",
    "English": "Palauan",
    "French": "palau",
    "German": "Palau-Sprache",
    "Portuguese": "palauano",
    "Italian": "Palauana",
    "Spanish": "Palau",
    "Dutch": "Palaus"
  },
  {
    "alpha2": "peo",
    "English": "Persian, Old (ca.600-400 B.C.)",
    "French": "perse, vieux (ca. 600-400 av. J.-C.)",
    "German": "Altpersisch",
    "Portuguese": "persa antigo (ca. 600-400 B.C.)",
    "Italian": "Persiano, antico (ca. 600-400 a.C.)",
    "Spanish": "Persa, antiguo (ca. 600-400 a. C.)",
    "Dutch": "Oudperzisch (ca.600-400 BC)"
  },
  {
    "alpha2": "phi",
    "English": "Philippine languages",
    "French": "philippines, langues",
    "German": "Philippinisch-Austronesisch (Andere)",
    "Portuguese": "filipina (Outras)",
    "Italian": "Filippine (Altre)",
    "Spanish": "Lenguas filipinas",
    "Dutch": "Filipijns (overige)"
  },
  {
    "alpha2": "phn",
    "English": "Phoenician",
    "French": "phénicien",
    "German": "Phönikisch",
    "Portuguese": "fenício",
    "Italian": "Fenicio",
    "Spanish": "Fenicio",
    "Dutch": "Fenicisch"
  },
  {
    "alpha2": "pli",
    "English": "Pali",
    "French": "pali",
    "German": "Pali",
    "Portuguese": "páli",
    "Italian": "Pali",
    "Spanish": "Pali",
    "Dutch": "Pali"
  },
  {
    "alpha2": "pol",
    "English": "Polish",
    "French": "polonais",
    "German": "Polnisch",
    "Portuguese": "polaco; polonês",
    "Italian": "Polacco",
    "Spanish": "polaco",
    "Dutch": "Pools"
  },
  {
    "alpha2": "pon",
    "English": "Pohnpeian",
    "French": "pohnpei",
    "German": "Ponapeanisch",
    "Portuguese": "ponpeiano‌",
    "Italian": "Ponape",
    "Spanish": "Pohnpeian",
    "Dutch": "Pohnpeiaans"
  },
  {
    "alpha2": "por",
    "English": "Portuguese",
    "French": "portugais",
    "German": "Portugiesisch",
    "Portuguese": "português",
    "Italian": "Portoghese",
    "Spanish": "portugués",
    "Dutch": "Portugees"
  },
  {
    "alpha2": "pra",
    "English": "Prakrit languages",
    "French": "prâkrit, langues",
    "German": "Prakrit",
    "Portuguese": "prakrit",
    "Italian": "Lingue pracrite",
    "Spanish": "Lenguas prakrit",
    "Dutch": "Prakrit"
  },
  {
    "alpha2": "pro",
    "English": "Provençal, Old (to 1500);Occitan, Old (to 1500)",
    "French": "provençal ancien (jusqu'à 1500); occitan ancien (jusqu'à 1500)",
    "German": "Altokzitanisch",
    "Portuguese": "provençal antigo (to 1500)",
    "Italian": "Antico provenzale (fino al 1500)",
    "Spanish": "Provenzal, viejo (hasta 1500); Occitano antiguo (hasta 1500)",
    "Dutch": "Oudprovençaals (tot 1500); Oud-occitaans (tot 1500)"
  },
  {
    "alpha2": "pus",
    "English": "Pushto; Pashto",
    "French": "pachto",
    "German": "Paschtu",
    "Portuguese": "pachto; pastó; afegão",
    "Italian": "Pashto",
    "Spanish": "Pushto ; Pashto",
    "Dutch": "Pasjtoe"
  },
  {
    "alpha2": "qaa-qtz",
    "English": "Reserved for local use",
    "French": "réservée à l'usage local",
    "German": "Reserviert für lokale Verwendung",
    "Portuguese": "Reservado para uso local",
    "Spanish": "Reservado para uso local",
    "Dutch": "gereserveerd voor lokaal gebruik"
  },
  {
    "alpha2": "que",
    "English": "Quechua",
    "French": "quechua",
    "German": "Quechua-Sprache",
    "Portuguese": "quíchua; quéchua",
    "Italian": "Quechua",
    "Spanish": "quechua",
    "Dutch": "Quechua"
  },
  {
    "alpha2": "raj",
    "English": "Rajasthani",
    "French": "rajasthani",
    "German": "Rajasthani",
    "Portuguese": "rajasthani",
    "Italian": "Rajasthani",
    "Spanish": "Rajasthani",
    "Dutch": "Rajasthani"
  },
  {
    "alpha2": "rap",
    "English": "Rapanui",
    "French": "rapanui",
    "German": "Osterinsel-Sprache",
    "Portuguese": "rapanui",
    "Italian": "Rapanui",
    "Spanish": "Rapa Nui",
    "Dutch": "Rapa Nui"
  },
  {
    "alpha2": "rar",
    "English": "Rarotongan; Cook Islands Maori",
    "French": "rarotonga; maori des îles Cook",
    "German": "Rarotonganisch",
    "Portuguese": "rarotonga",
    "Italian": "Rarotongano",
    "Spanish": "Rarotongan ; Islas Cook maoríes",
    "Dutch": "Rarotongaans"
  },
  {
    "alpha2": "roa",
    "English": "Romance languages",
    "French": "romanes, langues",
    "German": "Romanische Sprachen (Andere)",
    "Portuguese": "romance (Outras)",
    "Italian": "Lingue romanze (Altre)",
    "Spanish": "Lenguas romance",
    "Dutch": "Romaanse talen"
  },
  {
    "alpha2": "roh",
    "English": "Romansh",
    "French": "romanche",
    "German": "Rätoromanisch",
    "Portuguese": "reto-romano",
    "Italian": "romancio, Reto-romanzo",
    "Spanish": "Romanche",
    "Dutch": "Reto-Romaans"
  },
  {
    "alpha2": "rom",
    "English": "Romany",
    "French": "tsigane",
    "German": "Romani (Sprache)",
    "Portuguese": "romani",
    "Italian": "Romani",
    "Spanish": "gitano",
    "Dutch": "Romani"
  },
  {
    "alpha2": "ron",
    "English": "Romanian; Moldavian; Moldovan",
    "French": "roumain; moldave",
    "German": "Rumänisch",
    "Portuguese": "romeno",
    "Italian": "Romeno",
    "Spanish": "rumana ; Moldavo; Moldavo",
    "Dutch": "Roemeens"
  },
  {
    "alpha2": "run",
    "English": "Rundi",
    "French": "rundi",
    "German": "Rundi-Sprache",
    "Portuguese": "kirundi; rundi",
    "Italian": "Rundi",
    "Spanish": "Rundi",
    "Dutch": "Kirundi"
  },
  {
    "alpha2": "rup",
    "English": "Aromanian; Arumanian; Macedo-Romanian",
    "French": "aroumain; macédo-roumain",
    "German": "Aromunisch",
    "Spanish": "Aromanian ; Arumano; Macedo-rumano [b]",
    "Dutch": "Aroemeens"
  },
  {
    "alpha2": "rus",
    "English": "Russian",
    "French": "russe",
    "German": "Russisch",
    "Portuguese": "russo",
    "Italian": "Russo",
    "Spanish": "ruso",
    "Dutch": "Russisch"
  },
  {
    "alpha2": "sad",
    "English": "Sandawe",
    "French": "sandawe",
    "German": "Sandawe-Sprache",
    "Portuguese": "sandawe",
    "Italian": "Sandawe",
    "Spanish": "Sandawe",
    "Dutch": "Sandawe"
  },
  {
    "alpha2": "sag",
    "English": "Sango",
    "French": "sango",
    "German": "Sango-Sprache",
    "Portuguese": "sango",
    "Italian": "Sango",
    "Spanish": "Sango",
    "Dutch": "Sango"
  },
  {
    "alpha2": "sah",
    "English": "Yakut",
    "French": "iakoute",
    "German": "Jakutisch",
    "Portuguese": "yakut",
    "Italian": "Yakuto, Sakha",
    "Spanish": "Yakut",
    "Dutch": "Jakoets"
  },
  {
    "alpha2": "sai",
    "English": "South American Indian languages",
    "French": "sud-amérindiennes, langues",
    "German": "Indianersprachen, Südamerika (Andere)",
    "Portuguese": "Outras línguas indígenas da América do Sul",
    "Italian": "Lingue indiane sudamericane (Altre)",
    "Spanish": "Idiomas de los indios sudamericanos",
    "Dutch": "Zuid-Amerikaanse Indiaanse talen"
  },
  {
    "alpha2": "sal",
    "English": "Salishan languages",
    "French": "salishennes, langues",
    "German": "Salish-Sprache",
    "Portuguese": "salishano",
    "Italian": "Lingue salish",
    "Spanish": "Lenguas salishan",
    "Dutch": "Salishtalen"
  },
  {
    "alpha2": "sam",
    "English": "Samaritan Aramaic",
    "French": "samaritain",
    "German": "Samaritanisch",
    "Portuguese": "aramaico samaritano",
    "Italian": "Aramaico samaritano",
    "Spanish": "Arameo samaritano",
    "Dutch": "Samaritaans"
  },
  {
    "alpha2": "san",
    "English": "Sanskrit",
    "French": "sanskrit",
    "German": "Sanskrit",
    "Portuguese": "sânscrito",
    "Italian": "Sanscrito",
    "Spanish": "sánscrito",
    "Dutch": "Sanskriet"
  },
  {
    "alpha2": "sas",
    "English": "Sasak",
    "French": "sasak",
    "German": "Sasak",
    "Portuguese": "sasaque",
    "Italian": "Sasak",
    "Spanish": "Sasak",
    "Dutch": "Sasak"
  },
  {
    "alpha2": "sat",
    "English": "Santali",
    "French": "santal",
    "German": "Santali",
    "Portuguese": "santali",
    "Italian": "Santali",
    "Spanish": "Santali",
    "Dutch": "Santali"
  },
  {
    "alpha2": "scn",
    "English": "Sicilian",
    "French": "sicilien",
    "German": "Sizilianisch",
    "Portuguese": "siciliano",
    "Italian": "Siciliano",
    "Spanish": "siciliano",
    "Dutch": "Siciliaans"
  },
  {
    "alpha2": "sco",
    "English": "Scots",
    "French": "écossais",
    "German": "Schottisch",
    "Portuguese": "escocês",
    "Italian": "Scozzese",
    "Spanish": "escocés",
    "Dutch": "Schots"
  },
  {
    "alpha2": "sel",
    "English": "Selkup",
    "French": "selkoupe",
    "German": "Selkupisch",
    "Portuguese": "selkup",
    "Italian": "Selcupo",
    "Spanish": "Selkup",
    "Dutch": "Selkoeps"
  },
  {
    "alpha2": "sem",
    "English": "Semitic languages",
    "French": "sémitiques, langues",
    "German": "Semitische Sprachen (Andere)",
    "Portuguese": "(Outras) línguas semíticas",
    "Italian": "Lingue semitiche (Altre)",
    "Spanish": "Lenguas semíticas",
    "Dutch": "Semitische talen"
  },
  {
    "alpha2": "sga",
    "English": "Irish, Old (to 900)",
    "French": "irlandais ancien (jusqu'à 900)",
    "German": "Altirisch",
    "Portuguese": "irlandês antigo (a 900)",
    "Italian": "Irlandese, antico (to 900)",
    "Spanish": "Irlandés, viejo (hasta 900)",
    "Dutch": "Oud-iers (tot 900)"
  },
  {
    "alpha2": "sgn",
    "English": "Sign Languages",
    "French": "langues des signes",
    "German": "Zeichensprachen",
    "Portuguese": "línguas gestuais",
    "Italian": "Lingua dei segni",
    "Spanish": "Las lenguas de signos",
    "Dutch": "Gebarentalen"
  },
  {
    "alpha2": "shn",
    "English": "Shan",
    "French": "chan",
    "German": "Schan-Sprache",
    "Portuguese": "shan",
    "Italian": "Shan",
    "Spanish": "Shan",
    "Dutch": "Shan"
  },
  {
    "alpha2": "sid",
    "English": "Sidamo",
    "French": "sidamo",
    "German": "Sidamo-Sprache",
    "Portuguese": "sidamo",
    "Italian": "Sidamo",
    "Spanish": "Sidamo",
    "Dutch": "Sidamo"
  },
  {
    "alpha2": "sin",
    "English": "Sinhala; Sinhalese",
    "French": "singhalais",
    "German": "Singhalesisch",
    "Portuguese": "cingalês; sinhala",
    "Italian": "Singalese; Sinhala",
    "Spanish": "Cingalés ; Cingaleses",
    "Dutch": "Singalees"
  },
  {
    "alpha2": "sio",
    "English": "Siouan languages",
    "French": "sioux, langues",
    "German": "Sioux-Sprachen (Andere)",
    "Portuguese": "sioux",
    "Italian": "Lingue sioux",
    "Spanish": "Idiomas siouan",
    "Dutch": "Sioux-Catawbatalen"
  },
  {
    "alpha2": "sit",
    "English": "Sino-Tibetan languages",
    "French": "sino-tibétaines, langues",
    "German": "Sinotibetische Sprachen (Andere)",
    "Portuguese": "(Outras) línguas sino-tibetanas",
    "Italian": "Sinotibetane (Altre)",
    "Spanish": "Lenguas sino-tibetanas",
    "Dutch": "Sino-Tibetaanse talen"
  },
  {
    "alpha2": "sla",
    "English": "Slavic languages",
    "French": "slaves, langues",
    "German": "Slawische Sprachen (Andere)",
    "Portuguese": "(Outras) línguas eslavas",
    "Italian": "Lingue slave (Altre)",
    "Spanish": "Lenguas eslavas",
    "Dutch": "Slavische talen"
  },
  {
    "alpha2": "slk",
    "English": "Slovak",
    "French": "slovaque",
    "German": "Slowakisch",
    "Portuguese": "eslovaco",
    "Italian": "Slovacco",
    "Spanish": "eslovaco",
    "Dutch": "Slowaaks"
  },
  {
    "alpha2": "slv",
    "English": "Slovenian",
    "French": "slovène",
    "German": "Slowenisch",
    "Portuguese": "esloveno",
    "Italian": "Sloveno",
    "Spanish": "esloveno",
    "Dutch": "Sloveens"
  },
  {
    "alpha2": "sma",
    "English": "Southern Sami",
    "French": "sami du Sud",
    "German": "Südsaamisch",
    "Portuguese": "sami do sul",
    "Italian": "Sami meridionale",
    "Spanish": "Sami del Sur",
    "Dutch": "Zuid-Samisch"
  },
  {
    "alpha2": "sme",
    "English": "Northern Sami",
    "French": "sami du Nord",
    "German": "Nordsaamisch",
    "Portuguese": "sami do norte",
    "Italian": "Sami settentrionale",
    "Spanish": "Sami del Norte",
    "Dutch": "Noord-Samisch (Noord-Laps)"
  },
  {
    "alpha2": "smi",
    "English": "Sami languages",
    "French": "sames, langues",
    "German": "Saamisch",
    "Portuguese": "(Outras) sami",
    "Italian": "Lingue sami (Altre)",
    "Spanish": "Idiomas sami",
    "Dutch": "Samisch (Laps)"
  },
  {
    "alpha2": "smj",
    "English": "Lule Sami",
    "French": "sami de Lule",
    "German": "Lulesaamisch",
    "Portuguese": "sami lule",
    "Italian": "Sami di Lule",
    "Spanish": "Lule Sami",
    "Dutch": "Lule-Sami"
  },
  {
    "alpha2": "smn",
    "English": "Inari Sami",
    "French": "sami d'Inari",
    "German": "Inarisaamisch",
    "Portuguese": "sami inari",
    "Italian": "Sami di Inari",
    "Spanish": "Inari Sami",
    "Dutch": "Inari-Sami"
  },
  {
    "alpha2": "smo",
    "English": "Samoan",
    "French": "samoan",
    "German": "Samoanisch",
    "Portuguese": "samoano",
    "Italian": "Samoano",
    "Spanish": "Samoano",
    "Dutch": "Samoaans"
  },
  {
    "alpha2": "sms",
    "English": "Skolt Sami",
    "French": "sami skolt",
    "German": "Skoltsaamisch",
    "Portuguese": "sami skolt",
    "Italian": "Sami skolt",
    "Spanish": "Skolt Sami",
    "Dutch": "Skolt-Sami"
  },
  {
    "alpha2": "sna",
    "English": "Shona",
    "French": "shona",
    "German": "Schona-Sprache",
    "Portuguese": "chona",
    "Italian": "Shona",
    "Spanish": "Shona",
    "Dutch": "Shona"
  },
  {
    "alpha2": "snd",
    "English": "Sindhi",
    "French": "sindhi",
    "German": "Sindhi-Sprache",
    "Portuguese": "sindi",
    "Italian": "Sindhi",
    "Spanish": "Sindhi",
    "Dutch": "Sindhi"
  },
  {
    "alpha2": "snk",
    "English": "Soninke",
    "French": "soninké",
    "German": "Soninke-Sprache",
    "Portuguese": "soninke",
    "Italian": "Soninke",
    "Spanish": "Soninke",
    "Dutch": "Soninke"
  },
  {
    "alpha2": "sog",
    "English": "Sogdian",
    "French": "sogdien",
    "German": "Sogdisch",
    "Portuguese": "sogdiano",
    "Italian": "Sogdiano",
    "Spanish": "Sogdian",
    "Dutch": "Sogdisch"
  },
  {
    "alpha2": "som",
    "English": "Somali",
    "French": "somali",
    "German": "Somali",
    "Portuguese": "somali",
    "Italian": "Somalo",
    "Spanish": "somalí",
    "Dutch": "Somalisch"
  },
  {
    "alpha2": "son",
    "English": "Songhai languages",
    "French": "songhai, langues",
    "German": "Songhai-Sprache",
    "Portuguese": "songai",
    "Italian": "Songhai",
    "Spanish": "Idiomas Songhai",
    "Dutch": "Songhai"
  },
  {
    "alpha2": "sot",
    "English": "Sotho, Southern",
    "French": "sotho du Sud",
    "German": "Süd-Sotho-Sprache",
    "Portuguese": "soto do sul",
    "Italian": "Sesotho",
    "Spanish": "Sotho, Sur",
    "Dutch": "Zuid-Sotho"
  },
  {
    "alpha2": "spa",
    "English": "Spanish; Castilian",
    "French": "espagnol; castillan",
    "German": "Spanisch",
    "Portuguese": "castelhano; espanhol",
    "Italian": "Spagnolo; Castigliano",
    "Spanish": "español ; Castellano",
    "Dutch": "Spaans"
  },
  {
    "alpha2": "sqi",
    "English": "Albanian",
    "French": "albanais",
    "German": "Albanisch",
    "Portuguese": "albanês",
    "Italian": "Albanese",
    "Spanish": "albanés",
    "Dutch": "Albanees"
  },
  {
    "alpha2": "srd",
    "English": "Sardinian",
    "French": "sarde",
    "German": "Sardisch",
    "Portuguese": "sardo",
    "Italian": "Sardo",
    "Spanish": "sardo",
    "Dutch": "Sardijns"
  },
  {
    "alpha2": "srn",
    "English": "Sranan Tongo",
    "French": "sranan tongo",
    "German": "Sranantongo",
    "Spanish": "Sranan Tongo",
    "Dutch": "Surinaams"
  },
  {
    "alpha2": "srp",
    "English": "Serbian",
    "French": "serbe",
    "German": "Serbisch",
    "Portuguese": "sérvio",
    "Italian": "Serbo",
    "Spanish": "serbio",
    "Dutch": "Servisch"
  },
  {
    "alpha2": "srr",
    "English": "Serer",
    "French": "sérère",
    "German": "Serer-Sprache",
    "Portuguese": "serer",
    "Italian": "Serer",
    "Spanish": "Serer",
    "Dutch": "Sérères"
  },
  {
    "alpha2": "ssa",
    "English": "Nilo-Saharan languages",
    "French": "nilo-sahariennes, langues",
    "German": "Nilosaharanische Sprachen (Andere)",
    "Portuguese": "nilo-saharano (Outras)",
    "Italian": "Lingue nilo-sahariane (Altre)",
    "Spanish": "Lenguas nilo-saharianas",
    "Dutch": "Nilo-Saharaanse talen"
  },
  {
    "alpha2": "ssw",
    "English": "Swati",
    "French": "swati",
    "German": "Swasi-Sprache",
    "Portuguese": "suázi",
    "Italian": "Swati",
    "Spanish": "Swati",
    "Dutch": "Swazi"
  },
  {
    "alpha2": "suk",
    "English": "Sukuma",
    "French": "sukuma",
    "German": "Sukuma-Sprache",
    "Portuguese": "sukuma",
    "Italian": "Sukuma",
    "Spanish": "Sukuma",
    "Dutch": "Sukuma"
  },
  {
    "alpha2": "sun",
    "English": "Sundanese",
    "French": "soundanais",
    "German": "Sundanesisch",
    "Portuguese": "sundanês",
    "Italian": "Sondanese",
    "Spanish": "Sundanés",
    "Dutch": "Soendanees"
  },
  {
    "alpha2": "sus",
    "English": "Susu",
    "French": "soussou",
    "German": "Susu",
    "Portuguese": "susu",
    "Italian": "Susu",
    "Spanish": "Susu",
    "Dutch": "Susu"
  },
  {
    "alpha2": "sux",
    "English": "Sumerian",
    "French": "sumérien",
    "German": "Sumerisch",
    "Portuguese": "sumério",
    "Italian": "Sumero",
    "Spanish": "Sumerio",
    "Dutch": "Soemerisch"
  },
  {
    "alpha2": "swa",
    "English": "Swahili",
    "French": "swahili",
    "German": "Swahili",
    "Portuguese": "suaíli",
    "Italian": "Swahili",
    "Spanish": "swahili",
    "Dutch": "Swahili"
  },
  {
    "alpha2": "swe",
    "English": "Swedish",
    "French": "suédois",
    "German": "Schwedisch",
    "Portuguese": "sueco",
    "Italian": "Svedese",
    "Spanish": "sueco",
    "Dutch": "Zweeds"
  },
  {
    "alpha2": "syc",
    "English": "Classical Syriac",
    "French": "syriaque classique",
    "German": "Syrisch",
    "Spanish": "Siríaco clásico",
    "Dutch": "Klassiek Syrisch"
  },
  {
    "alpha2": "syr",
    "English": "Syriac",
    "French": "syriaque",
    "German": "Neuostaramäisch",
    "Portuguese": "siríaco",
    "Italian": "Siriaco",
    "Spanish": "Siríaco",
    "Dutch": "Syrisch"
  },
  {
    "alpha2": "tah",
    "English": "Tahitian",
    "French": "tahitien",
    "German": "Tahitisch",
    "Portuguese": "taitiano",
    "Italian": "Tahitiano",
    "Spanish": "Tahitiano",
    "Dutch": "Tahitiaans"
  },
  {
    "alpha2": "tai",
    "English": "Tai languages",
    "French": "tai, langues",
    "German": "Thaisprachen (Andere)",
    "Portuguese": "(Outras) línguas tailandesas",
    "Italian": "Thailandese (Altre)",
    "Spanish": "Idiomas tai",
    "Dutch": "Taitalen"
  },
  {
    "alpha2": "tam",
    "English": "Tamil",
    "French": "tamoul",
    "German": "Tamil",
    "Portuguese": "tâmil",
    "Italian": "Tamil",
    "Spanish": "Tamil",
    "Dutch": "Tamil"
  },
  {
    "alpha2": "tat",
    "English": "Tatar",
    "French": "tatar",
    "German": "Tatarisch",
    "Portuguese": "tártaro",
    "Italian": "Tataro",
    "Spanish": "Tártaro",
    "Dutch": "Tataars"
  },
  {
    "alpha2": "tel",
    "English": "Telugu",
    "French": "télougou",
    "German": "Telugu-Sprache",
    "Portuguese": "telugu",
    "Italian": "Telugu",
    "Spanish": "Telugu",
    "Dutch": "Telugu, Teloegoe"
  },
  {
    "alpha2": "tem",
    "English": "Timne",
    "French": "temne",
    "German": "Temne-Sprache",
    "Portuguese": "timne",
    "Italian": "Temne",
    "Spanish": "Timne",
    "Dutch": "Timne"
  },
  {
    "alpha2": "ter",
    "English": "Tereno",
    "French": "tereno",
    "German": "Tereno-Sprache",
    "Portuguese": "tereno",
    "Italian": "Tereno",
    "Spanish": "Tereno",
    "Dutch": "Tereno"
  },
  {
    "alpha2": "tet",
    "English": "Tetum",
    "French": "tetum",
    "German": "Tetum-Sprache",
    "Portuguese": "tetum",
    "Italian": "Tetum",
    "Spanish": "Tetum",
    "Dutch": "Tetun"
  },
  {
    "alpha2": "tgk",
    "English": "Tajik",
    "French": "tadjik",
    "German": "Tadschikisch",
    "Portuguese": "tajique",
    "Italian": "Tagico",
    "Spanish": "Tayiko",
    "Dutch": "Tadzjieks"
  },
  {
    "alpha2": "tgl",
    "English": "Tagalog",
    "French": "tagalog",
    "German": "Tagalog",
    "Portuguese": "tagalo",
    "Italian": "Tagalog",
    "Spanish": "Tagalo",
    "Dutch": "Tagalog"
  },
  {
    "alpha2": "tha",
    "English": "Thai",
    "French": "thaï",
    "German": "Thailändisch",
    "Portuguese": "tailandês",
    "Italian": "Thai",
    "Spanish": "tailandés",
    "Dutch": "Thai"
  },
  {
    "alpha2": "tig",
    "English": "Tigre",
    "French": "tigré",
    "German": "Tigre-Sprache",
    "Portuguese": "Tigre",
    "Italian": "Tigre",
    "Spanish": "Tigre",
    "Dutch": "Tigre"
  },
  {
    "alpha2": "tir",
    "English": "Tigrinya",
    "French": "tigrigna",
    "German": "Tigrinja-Sprache",
    "Portuguese": "tigrínia",
    "Italian": "Tigrino",
    "Spanish": "Tigrinya",
    "Dutch": "Tigrinya"
  },
  {
    "alpha2": "tiv",
    "English": "Tiv",
    "French": "tiv",
    "German": "Tiv-Sprache",
    "Portuguese": "tive",
    "Italian": "Tiv",
    "Spanish": "Tiv",
    "Dutch": "Tiv"
  },
  {
    "alpha2": "tkl",
    "English": "Tokelau",
    "French": "tokelau",
    "German": "Tokelauanisch",
    "Portuguese": "toquelauano",
    "Italian": "Tokelau",
    "Spanish": "Tokelau",
    "Dutch": "Tokelaus"
  },
  {
    "alpha2": "tlh",
    "English": "Klingon; tlhIngan-Hol",
    "French": "klingon",
    "German": "Klingonisch",
    "Portuguese": "klingon; tlhIngan-Hol",
    "Italian": "Klingon (costruita)",
    "Spanish": "Klingon ; tlhIngan-Hol",
    "Dutch": "Klingon"
  },
  {
    "alpha2": "tli",
    "English": "Tlingit",
    "French": "tlingit",
    "German": "Tlingit-Sprache",
    "Portuguese": "tlingit",
    "Italian": "Tlingit",
    "Spanish": "Tlingit",
    "Dutch": "Tlingit"
  },
  {
    "alpha2": "tmh",
    "English": "Tamashek",
    "French": "tamacheq",
    "German": "Tamašeq",
    "Portuguese": "tamasheque",
    "Italian": "Tamashek",
    "Spanish": "Tamashek",
    "Dutch": "Tamashek"
  },
  {
    "alpha2": "tog",
    "English": "Tonga (Nyasa)",
    "French": "tonga (Nyasa)",
    "German": "Tonga (Bantusprache, Sambia)",
    "Portuguese": "tonga",
    "Italian": "Tongano (Nyasa)",
    "Spanish": "Tonga (Nyasa)",
    "Dutch": "Tonga (Nyasa)"
  },
  {
    "alpha2": "ton",
    "English": "Tonga (Tonga Islands)",
    "French": "tongan (Îles Tonga)",
    "German": "Tongaisch",
    "Portuguese": "tonganês",
    "Italian": "Tonga (Tongano Islands)",
    "Spanish": "Tonga (Islas Tonga)",
    "Dutch": "Tongaans, Tonga"
  },
  {
    "alpha2": "tpi",
    "English": "Tok Pisin",
    "French": "tok pisin",
    "German": "Tok Pisin, Neuguinea-Pidgin",
    "Portuguese": "tok pisin",
    "Italian": "Tok Pisin",
    "Spanish": "Tok Pisin",
    "Dutch": "Tok Pisin"
  },
  {
    "alpha2": "tsi",
    "English": "Tsimshian",
    "French": "tsimshian",
    "German": "Tsimshian-Sprache",
    "Portuguese": "tsimshian",
    "Italian": "Tsimshian",
    "Spanish": "Tsimshian",
    "Dutch": "Tsimshiantalen"
  },
  {
    "alpha2": "tsn",
    "English": "Tswana",
    "French": "tswana",
    "German": "Tswana-Sprache",
    "Portuguese": "tswana",
    "Italian": "Tswana",
    "Spanish": "Tswana",
    "Dutch": "Tswana"
  },
  {
    "alpha2": "tso",
    "English": "Tsonga",
    "French": "tsonga",
    "German": "Tsonga-Sprache",
    "Portuguese": "tsonga",
    "Italian": "Tsonga",
    "Spanish": "Tsonga",
    "Dutch": "Tsonga"
  },
  {
    "alpha2": "tuk",
    "English": "Turkmen",
    "French": "turkmène",
    "German": "Turkmenisch",
    "Portuguese": "turcomano",
    "Italian": "Turcmeno",
    "Spanish": "Turcomano",
    "Dutch": "Turkmeens"
  },
  {
    "alpha2": "tum",
    "English": "Tumbuka",
    "French": "tumbuka",
    "German": "Tumbuka-Sprache",
    "Portuguese": "tumbuka",
    "Italian": "Tumbuka",
    "Spanish": "Tumbuka",
    "Dutch": "ChiTumbuka"
  },
  {
    "alpha2": "tup",
    "English": "Tupi languages",
    "French": "tupi, langues",
    "German": "Tupi-Sprache",
    "Portuguese": "tupi",
    "Italian": "Lingue tupi",
    "Spanish": "Idiomas tupi",
    "Dutch": "Tupi-talen"
  },
  {
    "alpha2": "tur",
    "English": "Turkish",
    "French": "turc",
    "German": "Türkisch",
    "Portuguese": "turco",
    "Italian": "Turco",
    "Spanish": "turco",
    "Dutch": "Turks"
  },
  {
    "alpha2": "tut",
    "English": "Altaic languages",
    "French": "altaïques, langues",
    "German": "Altaische Sprachen (Andere)",
    "Portuguese": "(Outras) línguas altaicas",
    "Italian": "Altaiche (Altre)",
    "Spanish": "Lenguas altaicas",
    "Dutch": "Altaïsche talen"
  },
  {
    "alpha2": "tvl",
    "English": "Tuvalu",
    "French": "tuvalu",
    "German": "Tuvaluisch",
    "Portuguese": "tuvaluano",
    "Italian": "Tuvaluano",
    "Spanish": "Tuvalu",
    "Dutch": "Tuvaluaans"
  },
  {
    "alpha2": "twi",
    "English": "Twi",
    "French": "twi",
    "German": "Twi-Sprache",
    "Portuguese": "twi",
    "Italian": "Twi",
    "Spanish": "Twi",
    "Dutch": "Twi"
  },
  {
    "alpha2": "tyv",
    "English": "Tuvinian",
    "French": "touva",
    "German": "Tuwinisch",
    "Portuguese": "tuviniano",
    "Italian": "Tuvan",
    "Spanish": "Tuvinian",
    "Dutch": "Toevaans"
  },
  {
    "alpha2": "udm",
    "English": "Udmurt",
    "French": "oudmourte",
    "German": "Udmurtisch",
    "Portuguese": "udmurt",
    "Italian": "Udmurt",
    "Spanish": "Udmurt",
    "Dutch": "Oedmoerts"
  },
  {
    "alpha2": "uga",
    "English": "Ugaritic",
    "French": "ougaritique",
    "German": "Ugaritisch",
    "Portuguese": "ugarítico",
    "Italian": "Ugaritico",
    "Spanish": "Ugarítico",
    "Dutch": "Ugaritisch"
  },
  {
    "alpha2": "uig",
    "English": "Uighur; Uyghur",
    "French": "ouïgour",
    "German": "Uigurisch",
    "Portuguese": "uigur",
    "Italian": "Uighuro; Uyghur",
    "Spanish": "Uigur ; Uigur",
    "Dutch": "Oeigoers"
  },
  {
    "alpha2": "ukr",
    "English": "Ukrainian",
    "French": "ukrainien",
    "German": "Ukrainisch",
    "Portuguese": "ucraniano",
    "Italian": "Ucraino",
    "Spanish": "ucranio",
    "Dutch": "Oekraïens"
  },
  {
    "alpha2": "umb",
    "English": "Umbundu",
    "French": "umbundu",
    "German": "Mbundu-Sprache",
    "Portuguese": "umbundu",
    "Italian": "Umbundu",
    "Spanish": "Umbundu",
    "Dutch": "Umbundu"
  },
  {
    "alpha2": "und",
    "English": "Undetermined",
    "French": "indéterminée",
    "German": "Nicht zu entscheiden",
    "Portuguese": "indeterminado (a língua não pôde ser identificada)",
    "Italian": "Indeterminata (lingua o lingue che non possono essere identificate)",
    "Spanish": "Indeterminado",
    "Dutch": "onbepaald"
  },
  {
    "alpha2": "urd",
    "English": "Urdu",
    "French": "ourdou",
    "German": "Urdu",
    "Portuguese": "urdu",
    "Italian": "Urdu",
    "Spanish": "Urdu",
    "Dutch": "Urdu"
  },
  {
    "alpha2": "uzb",
    "English": "Uzbek",
    "French": "ouszbek",
    "German": "Usbekisch",
    "Portuguese": "uzbeque; uzbek",
    "Italian": "Usbeco; usbeko, uzbeco, usbecco",
    "Spanish": "Uzbeko",
    "Dutch": "Oezbeeks"
  },
  {
    "alpha2": "vai",
    "English": "Vai",
    "French": "vaï",
    "German": "Vai-Sprache",
    "Portuguese": "vai",
    "Italian": "Vai",
    "Spanish": "Vai",
    "Dutch": "Vai"
  },
  {
    "alpha2": "ven",
    "English": "Venda",
    "French": "venda",
    "German": "Venda-Sprache",
    "Portuguese": "venda",
    "Italian": "Venda",
    "Spanish": "Venda",
    "Dutch": "Venda"
  },
  {
    "alpha2": "vie",
    "English": "Vietnamese",
    "French": "vietnamien",
    "German": "Vietnamesisch",
    "Portuguese": "vietnamita",
    "Italian": "Vietnamita",
    "Spanish": "vietnamita",
    "Dutch": "Vietnamees"
  },
  {
    "alpha2": "vol",
    "English": "Volapük",
    "French": "volapük",
    "German": "Volapük",
    "Portuguese": "volapuque",
    "Italian": "Volapük",
    "Spanish": "Volapük",
    "Dutch": "Volapük, Volapuk"
  },
  {
    "alpha2": "vot",
    "English": "Votic",
    "French": "vote",
    "German": "Wotisch",
    "Portuguese": "votico",
    "Italian": "Votico",
    "Spanish": "Votic",
    "Dutch": "Wotisch"
  },
  {
    "alpha2": "wak",
    "English": "Wakashan languages",
    "French": "wakashanes, langues",
    "German": "Wakash-Sprachen",
    "Portuguese": "wakashano",
    "Italian": "Lingue wakash",
    "Spanish": "Idiomas wakashan",
    "Dutch": "Wakashtalen"
  },
  {
    "alpha2": "wal",
    "English": "Wolaitta; Wolaytta",
    "French": "wolaitta; wolaytta",
    "German": "Walamo-Sprache",
    "Portuguese": "walamo",
    "Italian": "Wolaytta",
    "Spanish": "Wolaitta ; Wolaytta",
    "Dutch": "Walamo"
  },
  {
    "alpha2": "war",
    "English": "Waray",
    "French": "waray",
    "German": "Waray",
    "Portuguese": "waray-waray",
    "Italian": "Waray-Waray",
    "Spanish": "Waray",
    "Dutch": "Waray-Waray"
  },
  {
    "alpha2": "was",
    "English": "Washo",
    "French": "washo",
    "German": "Washo-Sprache",
    "Portuguese": "washo",
    "Italian": "Washo",
    "Spanish": "Washo",
    "Dutch": "Washo"
  },
  {
    "alpha2": "wen",
    "English": "Sorbian languages",
    "French": "sorabes, langues",
    "German": "Sorbisch (Andere)",
    "Portuguese": "línguas sorábias (lusácio)",
    "Italian": "Lingue lusaziane",
    "Spanish": "Lenguas sorabo",
    "Dutch": "Sorbische talen"
  },
  {
    "alpha2": "wln",
    "English": "Walloon",
    "French": "wallon",
    "German": "Wallonisch",
    "Portuguese": "valão",
    "Italian": "Vallone",
    "Spanish": "Valonia",
    "Dutch": "Waals"
  },
  {
    "alpha2": "wol",
    "English": "Wolof",
    "French": "wolof",
    "German": "Wolof-Sprache",
    "Portuguese": "uolofe",
    "Italian": "Wolof",
    "Spanish": "Wolof",
    "Dutch": "Wolof"
  },
  {
    "alpha2": "xal",
    "English": "Kalmyk; Oirat",
    "French": "kalmouk; oïrat",
    "German": "Kalmückisch",
    "Portuguese": "calmuc; oirat",
    "Italian": "Calmucco; Oirat",
    "Spanish": "Kalmyk ; Oirat",
    "Dutch": "Kalmuks"
  },
  {
    "alpha2": "xho",
    "English": "Xhosa",
    "French": "xhosa",
    "German": "Xhosa-Sprache",
    "Portuguese": "xhosa",
    "Italian": "Xhosa",
    "Spanish": "Xhosa",
    "Dutch": "Xhosa"
  },
  {
    "alpha2": "yao",
    "English": "Yao",
    "French": "yao",
    "German": "Yao-Sprache (Bantusprache)",
    "Portuguese": "yao",
    "Italian": "Yao",
    "Spanish": "Yao",
    "Dutch": "Yao"
  },
  {
    "alpha2": "yap",
    "English": "Yapese",
    "French": "yapois",
    "German": "Yapesisch",
    "Portuguese": "yapês",
    "Italian": "Yapese",
    "Spanish": "Yapés",
    "Dutch": "Yapees"
  },
  {
    "alpha2": "yid",
    "English": "Yiddish",
    "French": "yiddish",
    "German": "Jiddisch",
    "Portuguese": "iídiche",
    "Italian": "Yiddish",
    "Spanish": "Yídish",
    "Dutch": "Jiddisch"
  },
  {
    "alpha2": "yor",
    "English": "Yoruba",
    "French": "yoruba",
    "German": "Yoruba-Sprache",
    "Portuguese": "iorubá",
    "Italian": "Yoruba",
    "Spanish": "Yoruba",
    "Dutch": "Yoruba"
  },
  {
    "alpha2": "ypk",
    "English": "Yupik languages",
    "French": "yupik, langues",
    "German": "Ypik-Sprachen",
    "Portuguese": "yupique",
    "Italian": "yupik",
    "Spanish": "Idiomas yupik",
    "Dutch": "Yupiktalen"
  },
  {
    "alpha2": "zap",
    "English": "Zapotec",
    "French": "zapotèque",
    "German": "Zapotekisch",
    "Portuguese": "zapoteca",
    "Italian": "Zapotec",
    "Spanish": "Zapoteca",
    "Dutch": "Zapoteeks"
  },
  {
    "alpha2": "zbl",
    "English": "Blissymbols; Blissymbolics; Bliss",
    "French": "symboles Bliss; Bliss",
    "German": "Bliss-Symbol",
    "Spanish": "Blissymbols ; Blissymbolics ; felicidad",
    "Dutch": "Blissymbolen"
  },
  {
    "alpha2": "zen",
    "English": "Zenaga",
    "French": "zenaga",
    "German": "Zenaga",
    "Portuguese": "zenaga",
    "Italian": "Lingua zenaga",
    "Spanish": "Zenaga",
    "Dutch": "Zenaga"
  },
  {
    "alpha2": "zgh",
    "English": "Standard Moroccan Tamazight",
    "French": "amazighe standard marocain",
    "German": "Marokkanisches Tamazight",
    "Spanish": "Tamazight marroquí estándar"
  },
  {
    "alpha2": "zha",
    "English": "Zhuang; Chuang",
    "French": "zhuang; chuang",
    "German": "Zhuang",
    "Portuguese": "zhuang; chuang",
    "Italian": "Zhuang, Chuang",
    "Spanish": "Zhuang ; Chuang",
    "Dutch": "Zhuang, Tsjoeang"
  },
  {
    "alpha2": "zho",
    "English": "Chinese",
    "French": "chinois",
    "German": "Chinesisch",
    "Portuguese": "chinês",
    "Italian": "Cinese",
    "Spanish": "chino",
    "Dutch": "Chinese talen"
  },
  {
    "alpha2": "znd",
    "English": "Zande languages",
    "French": "zandé, langues",
    "German": "Zande-Sprachen",
    "Portuguese": "zande",
    "Italian": "Zande",
    "Spanish": "Idiomas Zande",
    "Dutch": "Zande"
  },
  {
    "alpha2": "zul",
    "English": "Zulu",
    "French": "zoulou",
    "German": "Zulu-Sprache",
    "Portuguese": "zulu",
    "Italian": "Zulu",
    "Spanish": "zulú",
    "Dutch": "Zoeloe"
  },
  {
    "alpha2": "zun",
    "English": "Zuni",
    "French": "zuni",
    "German": "Zuñi-Sprache",
    "Portuguese": "zunhi",
    "Italian": "Zuni",
    "Spanish": "Zuni",
    "Dutch": "Zuni"
  },
  {
    "alpha2": "zxx",
    "English": "No linguistic content; Not applicable",
    "French": "pas de contenu linguistique; non applicable",
    "German": "Kein linguistischer Inhalt",
    "Portuguese": "nenhum conteúdo linguístico",
    "Spanish": "Sin contenido lingüístico; No aplica",
    "Dutch": "geen taalkundige inhoud"
  },
  {
    "alpha2": "zza",
    "English": "Zaza; Dimili; Dimli; Kirdki; Kirmanjki; Zazaki",
    "French": "zaza; dimili; dimli; kirdki; kirmanjki; zazaki",
    "German": "Zazaki",
    "Spanish": "Zaza ; Dimili ; Dimli ; Kirdki ; Kirmanjki ; Zazaki",
    "Dutch": "Zazaki (Dimili; Dimli; Kirdki; Kirmanjki; Zaza)"
  }
]
